// // // // import React, { useState, useEffect, useMemo } from "react";
// // // // import { Button } from "./ui/button.jsx";
// // // // import { Input } from "./ui/input.jsx";
// // // // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card.jsx";
// // // // import { Badge } from "./ui/badge.jsx";
// // // // import { Search, Video, FileText, Image, Instagram, Facebook, MessageCircle, Newspaper, Smartphone, ExternalLink, Sun, Moon, Play, Eye, Clock, TrendingUp, Star, Settings, X, BookOpen } from "lucide-react";
// // // // import axios from "axios";
// // // // import SplitText from "./SplitText.js";
// // // // import Particles from "./Particles.js";
// // // // import TextType from "./TextType.js";
// // // // import CardNav from "./CardNav.js";
// // // // import Footer from "./Footer.js";
// // // // import CurvedLoop from "./CurvedLoop.js";
// // // // import { Dialog, DialogContent } from "./ui/dialog.jsx";

// // // // const ModernHomepage = () => {
// // // //   const [query, setQuery] = useState("");
// // // //   const [searchResult, setSearchResult] = useState(null);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [aiLoading, setAiLoading] = useState(false);
// // // //   const [allTags, setAllTags] = useState([]);
// // // //   const [allFetchedContent, setAllFetchedContent] = useState([]);

// // // //   // HAPUS: State darkMode tidak lagi diperlukan
// // // //   // const [darkMode, setDarkMode] = useState(false);

// // // //   const [activeContentTab, setActiveContentTab] = useState('video');
// // // //   const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
// // // //   const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
// // // //   const [currentPdfTitle, setCurrentPdfTitle] = useState("");

// // // //   const handleAnimationComplete = () => {
// // // //     console.log('Text animation completed!');
// // // //   };

// // // //   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // // //   const API = `${BACKEND_URL}/api`;

// // // //   const filteredContent = useMemo(() => {
// // // //     if (!allFetchedContent || allFetchedContent.length === 0) return [];

// // // //     switch (activeContentTab) {
// // // //       case 'video':
// // // //         return allFetchedContent.filter(c => c.content_type === 'video_youtube');

// // // //       case 'buku tutorial':
// // // //         return allFetchedContent.filter(c => c.content_type === 'file');

// // // //       case 'konten':
// // // //         return allFetchedContent.filter(c =>
// // // //           ['instagram_reel', 'instagram_feed', 'video_tiktok'].includes(c.content_type)
// // // //         );

// // // //       default:
// // // //         return allFetchedContent.filter(c => c.content_type === 'video_youtube');
// // // //     }
// // // //   }, [activeContentTab, allFetchedContent]);

// // // //   const trendingContent = useMemo(() => {
// // // //     return allFetchedContent.slice(0, 5);
// // // //   }, [allFetchedContent]);

// // // //   useEffect(() => {
// // // //     fetchInitialData();

// // // //     // --- LOGIKA LIGHT MODE PERMANEN ---
// // // //     // 1. Paksa hapus class 'dark' dari elemen HTML
// // // //     document.documentElement.classList.remove('dark');
// // // //     // 2. Hapus preferensi tema yang mungkin tersimpan di browser user
// // // //     localStorage.removeItem('theme');

// // // //     const loadScript = (id, src) => {
// // // //       if (!document.getElementById(id)) {
// // // //         const script = document.createElement('script');
// // // //         script.id = id;
// // // //         script.src = src;
// // // //         script.async = true;
// // // //         document.body.appendChild(script);
// // // //       }
// // // //     };

// // // //     loadScript('tiktok-embed-script', 'https://www.tiktok.com/embed.js');
// // // //     loadScript('instagram-embed-script', '//www.instagram.com/embed.js');

// // // //   }, []);

// // // //   // HAPUS: useEffect untuk memantau embed instgrm saat konten berubah
// // // //   // Kita gabungkan logika reload embed ke useEffect konten di bawah atau biarkan di sini jika terpisah
// // // //   useEffect(() => {
// // // //     const timer = setTimeout(() => {
// // // //       if (window.instgrm) {
// // // //         window.instgrm.Embeds.process();
// // // //       }
// // // //     }, 500);
// // // //     return () => clearTimeout(timer);
// // // //   }, [filteredContent, activeContentTab]);

// // // //   // HAPUS: useEffect yang mengatur class dark mode berdasarkan state
// // // //   /*
// // // //   useEffect(() => {
// // // //     if (darkMode) {
// // // //       document.documentElement.classList.add('dark');
// // // //     } else {
// // // //       document.documentElement.classList.remove('dark');
// // // //     }
// // // //     localStorage.setItem('theme', darkMode ? 'dark' : 'light');
// // // //   }, [darkMode]);
// // // //   */

// // // //   const fetchInitialData = async () => {
// // // //     try {
// // // //       const tagsResponse = await axios.get(`${API}/search/tags`);
// // // //       console.log(tagsResponse.data)
// // // //       setAllTags(tagsResponse.data.slice(0, 12));

// // // //       const contentTypes = ['video_youtube', 'file', 'instagram_reel', 'instagram_feed', 'video_tiktok'];

// // // //       const responses = await Promise.all(
// // // //         contentTypes.map(type => axios.get(`${API}/content/by-type/${type}`))
// // // //       );

// // // //       const allContent = [];
// // // //       responses.forEach(response => {
// // // //         if (response.data && Array.isArray(response.data.content)) {
// // // //           allContent.push(...response.data.content);
// // // //         }
// // // //       });

// // // //       const uniqueContent = Array.from(new Map(allContent.map(item => [item.id, item])).values());
// // // //       const shuffled = uniqueContent.sort(() => 0.5 - Math.random());
// // // //       setAllFetchedContent(shuffled);

// // // //     } catch (error) {
// // // //       console.error("Error fetching initial data:", error);
// // // //     }
// // // //   };

// // // //   const getContentImage = (content) => {
// // // //     if (content.content_type === 'image' && content.content_data.url) {
// // // //       const separator = content.content_data.url.includes('?') ? '&' : '?';
// // // //       return `${content.content_data.url}${separator}v=${Date.now()}`;
// // // //     }
// // // //     if (content.content_type === 'video_youtube') {
// // // //       const embedUrl = content.content_data.embed_url;
// // // //       const videoId = embedUrl?.match(/embed\/([^?]*)/)?.[1];
// // // //       return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '/api/placeholder/600/300';
// // // //     }
// // // //     if (content.content_data.thumbnail_url) {
// // // //       const separator = content.content_data.thumbnail_url.includes('?') ? '&' : '?';
// // // //       return `${content.content_data.thumbnail_url}${separator}v=${Date.now()}`;
// // // //     }
// // // //     return '/api/placeholder/600/300';
// // // //   };

// // // //   const getContentLink = (content) => {
// // // //     if (content.content_type === 'video_youtube') {
// // // //       return content.content_data.embed_url?.replace('embed/', 'watch?v=');
// // // //     }
// // // //     if (content.content_type === 'video_upload' || content.content_type === 'video_tiktok') {
// // // //       return content.content_data.original_url || content.content_data.url;
// // // //     }
// // // //     if (content.content_type.includes('instagram')) {
// // // //       return content.content_data.original_url;
// // // //     }
// // // //     if (content.content_type === 'article') {
// // // //       if (content.content_data.pdf_url) {
// // // //         return content.content_data.pdf_url;
// // // //       }
// // // //       return `/article/${content.id}`;
// // // //     }
// // // //     if (content.content_type === 'file') {
// // // //       return content.content_data.url;
// // // //     }
// // // //     if (content.content_type === 'image') {
// // // //       return content.content_data.url;
// // // //     }
// // // //     return content.content_data.url || '#';
// // // //   };

// // // //   const handleSearch = async (searchQuery = query) => {
// // // //     if (!searchQuery.trim()) return;
// // // //     setLoading(true);
// // // //     try {
// // // //       const localResponse = await axios.post(`${API}/search/content`, { query: searchQuery });
// // // //       const localResults = [...(localResponse.data.related_videos || []), ...(localResponse.data.related_content || [])];
// // // //       setSearchResult({
// // // //         query: searchQuery,
// // // //         local_results: localResults,
// // // //         ai_response: null,
// // // //         ai_loading: true
// // // //       });
// // // //       setAiLoading(true);
// // // //       const aiResponse = await axios.post(`${API}/search/ai`, { query: searchQuery });
// // // //       setSearchResult(prev => ({ ...prev, ai_response: aiResponse.data.ai_response, ai_loading: false }));
// // // //     } catch (error) {
// // // //       console.error("Search error:", error);
// // // //     } finally {
// // // //       setLoading(false);
// // // //       setAiLoading(false);
// // // //     }
// // // //   };

// // // //   const handleKeyPress = (e) => {
// // // //     if (e.key === 'Enter') {
// // // //       handleSearch();
// // // //     }
// // // //   };

// // // //   const handleTagClick = (tag) => {
// // // //     setQuery(tag);
// // // //     handleSearch(tag);
// // // //   };

// // // //   const formatTimeAgo = (dateString) => {
// // // //     const date = new Date(dateString);
// // // //     const now = new Date();
// // // //     const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
// // // //     if (diffInHours < 1) return 'Baru saja';
// // // //     if (diffInHours < 24) return `${diffInHours} jam yang lalu`;
// // // //     const diffInDays = Math.floor(diffInHours / 24);
// // // //     if (diffInDays < 7) return `${diffInDays} hari yang lalu`;
// // // //     return date.toLocaleDateString('id-ID');
// // // //   };

// // // //   const handleDownloadPdf = async () => {
// // // //     try {
// // // //       const downloadUrl = `${API}/download-pdf?url=${encodeURIComponent(currentPdfUrl)}&filename=${encodeURIComponent(currentPdfTitle + '.pdf')}`;

// // // //       const link = document.createElement('a');
// // // //       link.href = downloadUrl;
// // // //       link.download = currentPdfTitle + '.pdf';
// // // //       document.body.appendChild(link);
// // // //       link.click();
// // // //       document.body.removeChild(link);
// // // //     } catch (error) {
// // // //       console.error('Download error:', error);
// // // //       const link = document.createElement('a');
// // // //       link.href = currentPdfUrl;
// // // //       link.download = currentPdfTitle + '.pdf';
// // // //       link.target = '_blank';
// // // //       document.body.appendChild(link);
// // // //       link.click();
// // // //       document.body.removeChild(link);
// // // //     }
// // // //   };

// // // //   const handleContentClick = (content) => {
// // // //     if (content.content_data.embed_code || content.content_data.embed_html) return;

// // // //     if (content.content_type === 'file' && content.content_data.url && content.content_data.url.toLowerCase().endsWith('.pdf')) {
// // // //       setCurrentPdfUrl(content.content_data.url);
// // // //       setCurrentPdfTitle(content.title);
// // // //       setPdfViewerOpen(true);
// // // //       return;
// // // //     }

// // // //     if (content.content_type === 'article' && content.content_data.pdf_url) {
// // // //       setCurrentPdfUrl(content.content_data.pdf_url);
// // // //       setCurrentPdfTitle(content.title);
// // // //       setPdfViewerOpen(true);
// // // //       return;
// // // //     }

// // // //     const contentLink = getContentLink(content);
// // // //     if (contentLink !== '#') {
// // // //       window.open(contentLink, '_blank');
// // // //     }
// // // //   };

// // // //   const closePdfViewer = () => {
// // // //     setPdfViewerOpen(false);
// // // //     setCurrentPdfUrl(null);
// // // //     setCurrentPdfTitle("");
// // // //   };

// // // //   const renderContent = (content) => {
// // // //     switch (content.content_type) {
// // // //       case 'video_youtube':
// // // //         return (
// // // //           <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden group">
// // // //             {content.content_data.embed_url ? (
// // // //               <iframe
// // // //                 src={content.content_data.embed_url}
// // // //                 title={content.title}
// // // //                 className="w-full h-full rounded-lg"
// // // //                 allowFullScreen
// // // //                 frameBorder="0"
// // // //               />
// // // //             ) : (
// // // //               <img src={getContentImage(content)} alt={content.title} className="w-full h-full object-cover" />
// // // //             )}
// // // //             <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
// // // //               <Video className="w-3 h-3 inline mr-1" /> Video
// // // //             </div>
// // // //           </div>
// // // //         );
// // // //       case 'video_tiktok':
// // // //         return (
// // // //           <div className="flex justify-center items-center bg-transparent rounded-lg">
// // // //             {content.content_data.embed_html ? (
// // // //               <div className="w-full [&>blockquote]:m-0 [&>blockquote]:mx-auto" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
// // // //             ) : (
// // // //               <a href={content.content_data.original_url} target="_blank" rel="noopener noreferrer" className="text-white bg-black rounded p-4 block">Lihat di TikTok</a>
// // // //             )}
// // // //           </div>
// // // //         );
// // // //       case 'video_upload':
// // // //         return (
// // // //           <div className="relative bg-gray-100 rounded-lg overflow-hidden group cursor-pointer" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || '16/9' }} onClick={() => handleContentClick(content)}>
// // // //             {content.content_data.url ? (
// // // //               <video controls playsInline className="w-full h-full rounded-lg object-cover"><source src={content.content_data.url} type="video/mp4" /></video>
// // // //             ) : <div className="flex items-center justify-center h-full text-gray-400"><Video className="w-8 h-8" /></div>}
// // // //             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Video className="w-3 h-3 inline mr-1" /> Video Upload</div>
// // // //           </div>
// // // //         );
// // // //       case 'instagram_reel':
// // // //       case 'instagram_feed':
// // // //         if (content.content_data.embed_code) {
// // // //           return (
// // // //             <div className="flex justify-center w-full bg-white rounded-lg overflow-hidden p-2">
// // // //               <div className="instagram-embed-wrapper w-full flex justify-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
// // // //             </div>
// // // //           );
// // // //         }
// // // //         return (
// // // //           <div className="relative bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || (content.content_type === 'instagram_reel' ? '9/16' : '1/1'), minHeight: '300px' }} onClick={() => handleContentClick(content)}>
// // // //             {content.content_data.thumbnail_url ? <img src={content.content_data.thumbnail_url} alt={content.title} className="w-full h-full object-cover" /> : <div className="flex items-center justify-center h-full text-white"><Instagram className="w-8 h-8" /></div>}
// // // //             <div className="absolute bottom-2 left-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs px-2 py-1 rounded"><Instagram className="w-3 h-3 inline mr-1" /> {content.content_type === 'instagram_reel' ? 'Reel' : 'Post'}</div>
// // // //           </div>
// // // //         );
// // // //       case 'image':
// // // //         return (
// // // //           <div className="relative bg-gray-100 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || 'auto' }} onClick={() => handleContentClick(content)}>
// // // //             <img src={content.content_data.url} alt={content.title} className="w-full h-full object-cover" onError={(e) => { e.target.src = '/api/placeholder/600/300'; }} />
// // // //             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Image className="w-3 h-3 inline mr-1" /> Gambar</div>
// // // //           </div>
// // // //         );
// // // //       case 'article':
// // // //         if (content.content_data.pdf_url) {
// // // //           return (
// // // //             <div className="relative aspect-video bg-gradient-to-br from-red-100 to-orange-100 rounded-lg overflow-hidden cursor-pointer group" onClick={() => handleContentClick(content)}>
// // // //               <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
// // // //                 <FileText className="w-12 h-12 mb-3 text-red-600" />
// // // //                 <p className="text-sm font-semibold text-center mb-2 text-gray-800">{content.title}</p>
// // // //                 <Badge className="bg-red-500 text-white">PDF Tutorial</Badge>
// // // //               </div>
// // // //               <div className="absolute inset-0 bg-red-500 opacity-0 group-hover:opacity-10 transition-opacity"></div>
// // // //             </div>
// // // //           );
// // // //         }
// // // //         return (
// // // //           <div className="aspect-video bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
// // // //             <div className="text-center">
// // // //               <FileText className="w-8 h-8 mx-auto mb-2 text-blue-600" />
// // // //               <p className="text-sm text-gray-600 line-clamp-3">{content.content_data.text?.substring(0, 100)}...</p>
// // // //             </div>
// // // //           </div>
// // // //         );
// // // //       case 'file':
// // // //         const isPdf = content.content_data?.url?.toLowerCase().endsWith('.pdf');
// // // //         const coverImage = content.content_data?.cover_image_url;

// // // //         // JIKA ADA COVER IMAGE
// // // //         if (coverImage) {
// // // //           return (
// // // //             <div
// // // //               className="relative aspect-video rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02] bg-cover bg-center"
// // // //               style={{ backgroundImage: `url(${coverImage})` }}
// // // //               onClick={() => handleContentClick(content)}
// // // //             >
// // // //               <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors"></div>

// // // //               <div className="relative z-10 flex flex-col items-center">
// // // //                 <BookOpen className="w-12 h-12 mb-2 opacity-90 drop-shadow-md" />
// // // //                 <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2 drop-shadow-md px-2">{content.title}</p>
// // // //                 <p className="text-[9px] opacity-90 text-center mt-1 bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded-full">Klik untuk membaca</p>
// // // //               </div>

// // // //               {isPdf && (
// // // //                 <div className="absolute top-2 right-2 bg-red-600 shadow-md text-white text-[9px] font-bold px-1.5 py-0.5 rounded z-10">PDF</div>
// // // //               )}
// // // //             </div>
// // // //           );
// // // //         }

// // // //         // DEFAULT FALLBACK (JIKA TIDAK ADA COVER IMAGE)
// // // //         if (isPdf) {
// // // //           return (
// // // //             <div className="relative aspect-video bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02]" onClick={() => handleContentClick(content)}>
// // // //               <BookOpen className="w-12 h-12 mb-2 opacity-90" />
// // // //               <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2">{content.title}</p>
// // // //               <p className="text-[9px] opacity-75 text-center mt-1 bg-white/20 px-2 py-0.5 rounded-full">Klik untuk membaca</p>
// // // //               <div className="absolute top-2 right-2 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">PDF</div>
// // // //             </div>
// // // //           );
// // // //         }
// // // //         return (
// // // //           <div className="aspect-video bg-gradient-to-br from-green-100 to-blue-100 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
// // // //             <div className="text-center">
// // // //               <FileText className="w-8 h-8 mx-auto mb-2 text-green-600" />
// // // //               <p className="text-sm text-gray-600 mb-2">{content.content_data.file_name || 'File'}</p>
// // // //               <Button className="bg-green-600 text-white hover:bg-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300" size="sm"><ExternalLink className="w-4 h-4 mr-2" /> Download File</Button>
// // // //             </div>
// // // //           </div>
// // // //         );
// // // //       default:
// // // //         return <div className="aspect-video bg-gray-100 rounded-lg flex items-center justify-center"><FileText className="w-8 h-8 text-gray-400" /></div>;
// // // //     }
// // // //   };

// // // //   // Warna partikel untuk mode terang saja
// // // //   const particleColors = ['#1e1e1e', '#3b82f6', '#1d4ed8'];

// // // //   const navItems = [
// // // //     {
// // // //       label: "Tentang",
// // // //       bgColor: "#0D0716",
// // // //       textColor: "#fff",
// // // //       links: [
// // // //         { label: "Perusahaan", ariaLabel: "Tentang Perusahaan", href: "https://mpstore.co.id/about" },
// // // //         { label: "Karir", ariaLabel: "Karir", href: "https://mpstore.co.id/career" }
// // // //       ]
// // // //     },
// // // //     {
// // // //       label: "Layanan",
// // // //       bgColor: "#170D27",
// // // //       textColor: "#fff",
// // // //       links: [
// // // //         { label: "QRIS", ariaLabel: "QRIS", href: "https://mpstore.co.id/apps" },
// // // //         { label: "Agen Pulsa & PPOB", ariaLabel: "Agen Pulsa & PPOB", href: "#" },
// // // //         { label: "Kulakan Indomarco", ariaLabel: "Kulakan Indomarco", href: "#" },
// // // //         { label: "Logistik Kasir", ariaLabel: "Logistik Kasir", href: "#" },
// // // //         { label: "Akses Permodalan", ariaLabel: "Akses Permodalan", href: "#" },
// // // //         { label: "Miniweb", ariaLabel: "Miniweb", href: "#" }
// // // //       ]
// // // //     },
// // // //     {
// // // //       label: "Bantuan",
// // // //       bgColor: "#271E37",
// // // //       textColor: "#fff",
// // // //       links: [
// // // //         { label: "WhatsApp CS", ariaLabel: "Hubungi CS", href: "https://api.whatsapp.com/send/?phone=6285812626667" },
// // // //         { label: "Email", ariaLabel: "Email Kami", href: "mailto:support@mpstore.co.id" },
// // // //         { label: "FAQ", ariaLabel: "Tanya Jawab", href: "#" }
// // // //       ]
// // // //     }
// // // //   ];

// // // //   return (
// // // //     // CLASS 'dark' DIHAPUS DARI SINI. Hanya pakai class biasa.
// // // //     <div className="min-h-screen transition-colors duration-300 relative text-gray-900">

// // // //       <Particles
// // // //         particleColors={particleColors}
// // // //         particleCount={200}
// // // //         particleSpread={10}
// // // //         speed={0.1}
// // // //         particleBaseSize={100}
// // // //         moveParticlesOnHover={true}
// // // //         alphaParticles={false}
// // // //         disableRotation={false}
// // // //         className="fixed inset-0 w-full h-full"
// // // //       />

// // // //       {/* PDF Viewer Modal */}
// // // //       {pdfViewerOpen && (
// // // //         <Dialog open={pdfViewerOpen} onOpenChange={setPdfViewerOpen}>
// // // //           <DialogContent className="max-w-5xl w-[95vw] h-[90vh] p-0 overflow-hidden bg-zinc-900 border-zinc-800">
// // // //             <div className="flex flex-col h-full">
// // // //               <div className="flex items-center justify-between p-4 bg-zinc-900 text-white border-b border-zinc-800">
// // // //                 <h3 className="font-medium truncate flex items-center gap-2">
// // // //                   <BookOpen className="w-5 h-5 text-blue-400" />
// // // //                   {currentPdfTitle || "Document Viewer"}
// // // //                 </h3>
// // // //                 <div className="flex items-center gap-2">
// // // //                   <button
// // // //                     onClick={handleDownloadPdf}
// // // //                     className="text-xs bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
// // // //                   >
// // // //                     <ExternalLink className="w-3 h-3 mr-1" /> Download
// // // //                   </button>
// // // //                   <a
// // // //                     href={currentPdfUrl}
// // // //                     target="_blank"
// // // //                     rel="noreferrer"
// // // //                     className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
// // // //                   >
// // // //                     <ExternalLink className="w-3 h-3 mr-1" /> Buka Full
// // // //                   </a>
// // // //                   <button onClick={() => setPdfViewerOpen(false)} className="text-zinc-400 hover:text-white">
// // // //                     <X className="w-6 h-6" />
// // // //                   </button>
// // // //                 </div>
// // // //               </div>
// // // //               <div className="flex-1 bg-zinc-800 relative">
// // // //                 {currentPdfUrl ? (
// // // //                   <iframe
// // // //                     src={`${currentPdfUrl}#toolbar=0&view=FitH`}
// // // //                     title="PDF Viewer"
// // // //                     className="w-full h-full absolute inset-0 border-0"
// // // //                   />
// // // //                 ) : (
// // // //                   <div className="flex items-center justify-center h-full text-zinc-500">
// // // //                     Memuat Dokumen...
// // // //                   </div>
// // // //                 )}
// // // //               </div>
// // // //             </div>
// // // //           </DialogContent>
// // // //         </Dialog>
// // // //       )}

// // // //       <div className="relative z-10 flex flex-col min-h-screen">
// // // //         <CardNav
// // // //           logo="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
// // // //           logoAlt="MPStore Logo"
// // // //           items={navItems}
// // // //           // HARDCODE WARNA LIGHT MODE
// // // //           baseColor="rgba(255, 255, 255, 0.8)"
// // // //           menuColor="#000"
// // // //           buttonBgColor="#2563eb"
// // // //           buttonTextColor="#fff"
// // // //           ease="power3.out"
// // // //         />

// // // //         <main className="container mx-auto px-4 py-8 pt-32 flex-grow">

// // // //           <div className="mb-8 w-full flex flex-col items-center text-center gap-6">
// // // //             <div className="w-full overflow-hidden mt-8">
// // // //               <SplitText
// // // //                 text="Selamat Datang di MPStore Training Center"
// // // //                 className="text-4xl md:text-5xl font-bold text-center text-blue-600 pb-2 drop-shadow-md"
// // // //                 delay={50}
// // // //                 duration={1}
// // // //                 ease="back.out(1.7)"
// // // //                 threshold={0.1}
// // // //                 rootMargin="-50px"
// // // //                 onLetterAnimationComplete={handleAnimationComplete}
// // // //               />
// // // //             </div>

// // // //             <div className="min-h-[40px]">
// // // //               <TextType
// // // //                 text={[
// // // //                   "Belajar fitur-fitur MPStore dengan mudah",
// // // //                   "Tutorial lengkap untuk kembangkan bisnismu",
// // // //                   "Kelola usaha jadi lebih efisien!"
// // // //                 ]}
// // // //                 className="text-lg md:text-xl text-gray-600 font-medium"
// // // //                 typingSpeed={50}
// // // //                 pauseDuration={2000}
// // // //                 deletingSpeed={30}
// // // //                 cursorCharacter="|"
// // // //                 cursorClassName="text-blue-500 font-bold"
// // // //               />
// // // //             </div>

// // // //             <div className="w-full max-w-2xl mx-auto mt-4">
// // // //               <div className="relative group">
// // // //                 <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 blur"></div>
// // // //                 <div className="relative flex bg-white rounded-full p-1">
// // // //                   <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// // // //                   <Input
// // // //                     type="text"
// // // //                     placeholder="Cari tutorial, tips, atau tanyakan apapun..."
// // // //                     value={query}
// // // //                     onChange={(e) => setQuery(e.target.value)}
// // // //                     onKeyPress={handleKeyPress}
// // // //                     className="pl-12 pr-4 py-6 w-full bg-transparent border-0 focus:ring-0 focus-visible:ring-0 rounded-full text-lg"
// // // //                   />
// // // //                   {query && (
// // // //                     <Button
// // // //                       onClick={() => handleSearch()}
// // // //                       disabled={loading}
// // // //                       className="rounded-full px-8 bg-blue-600 hover:bg-blue-700 text-white"
// // // //                     >
// // // //                       {loading ? '...' : 'Cari'}
// // // //                     </Button>
// // // //                   )}
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           </div>

// // // //           {searchResult && (
// // // //             <section className="mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
// // // //               <div className="max-w-4xl mx-auto space-y-8">
// // // //                 <div className="text-center">
// // // //                   <h2 className="text-3xl font-bold mb-4">
// // // //                     Hasil pencarian: "{searchResult.query}"
// // // //                   </h2>
// // // //                   <Button variant="outline" onClick={() => setSearchResult(null)} className="rounded-full">
// // // //                     ← Kembali ke Beranda
// // // //                   </Button>
// // // //                 </div>

// // // //                 <Card className="bg-white/90 backdrop-blur-sm border-l-4 border-blue-500 shadow-lg">
// // // //                   <CardHeader>
// // // //                     <CardTitle className="flex items-center gap-2">
// // // //                       <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
// // // //                         <span className="text-white text-sm font-bold">AI</span>
// // // //                       </div>
// // // //                       Jawaban AI
// // // //                     </CardTitle>
// // // //                   </CardHeader>
// // // //                   <CardContent>
// // // //                     {searchResult.ai_loading ? (
// // // //                       <div className="flex items-center gap-2">
// // // //                         <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
// // // //                         <span className="text-gray-600">Sedang menganalisis...</span>
// // // //                       </div>
// // // //                     ) : searchResult.ai_response ? (
// // // //                       <div className="prose prose-sm max-w-none">
// // // //                         <p className="whitespace-pre-wrap">{searchResult.ai_response}</p>
// // // //                       </div>
// // // //                     ) : (
// // // //                       <p className="text-gray-500">Tidak ada respons AI yang tersedia.</p>
// // // //                     )}
// // // //                   </CardContent>
// // // //                 </Card>

// // // //                 {searchResult.local_results && searchResult.local_results.length > 0 && (
// // // //                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
// // // //                     {searchResult.local_results.map((content) => (
// // // //                       <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/80 backdrop-blur-sm overflow-hidden cursor-pointer" onClick={() => handleContentClick(content)}>
// // // //                         <div className="relative">{renderContent(content)}</div>
// // // //                         <CardContent className="p-4">
// // // //                           <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
// // // //                             <span>{formatTimeAgo(content.created_at)}</span>
// // // //                           </div>
// // // //                           <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
// // // //                             {content.title}
// // // //                           </h4>
// // // //                         </CardContent>
// // // //                       </Card>
// // // //                     ))}
// // // //                   </div>
// // // //                 )}
// // // //               </div>
// // // //             </section>
// // // //           )}

// // // //           {!searchResult && (
// // // //             <>
// // // //               <section className="mb-8 mt-12">
// // // //                 <h3 className="text-2xl font-bold mb-6 text-center">Kategori Populer</h3>
// // // //                 <div className="flex flex-wrap justify-center gap-3">
// // // //                   {allTags.map((tag) => (
// // // //                     <Button key={tag} variant="outline" onClick={() => handleTagClick(tag)} className="rounded-full bg-white/50 hover:bg-blue-50 border-gray-300 backdrop-blur-sm">
// // // //                       {tag}
// // // //                     </Button>
// // // //                   ))}
// // // //                 </div>
// // // //               </section>

// // // //               <div className="mb-1">
// // // //                 <CurvedLoop
// // // //                   marqueeText="Kasir | Qris | Akses Permodalan | Mini Website | Agen Pulsa & PPOB | Kulakan Indomarco | Logistik"
// // // //                   speed={2}
// // // //                   curveAmount={0}
// // // //                   className="text-grey-600"
// // // //                 />
// // // //               </div>

// // // //               <section className="mb-8">
// // // //                 <div className="flex space-x-1 mb-6 bg-gray-100/80 p-1 rounded-full max-w-md backdrop-blur-sm mx-auto">
// // // //                   {[
// // // //                     { id: 'video', label: 'Video' },
// // // //                     { id: 'buku tutorial', label: 'Buku Tutorial' },
// // // //                     { id: 'konten', label: 'Konten' }
// // // //                   ].map((tab) => (
// // // //                     <Button
// // // //                       key={tab.id}
// // // //                       variant={activeContentTab === tab.id ? "default" : "ghost"}
// // // //                       size="sm"
// // // //                       onClick={() => setActiveContentTab(tab.id)}
// // // //                       className={`flex-1 rounded-full transition-all ${activeContentTab === tab.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
// // // //                     >
// // // //                       {tab.label}
// // // //                     </Button>
// // // //                   ))}
// // // //                 </div>
// // // //               </section>

// // // //               <div className="grid lg:grid-cols-4 gap-8">
// // // //                 <div className="lg:col-span-3">
// // // //                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-y-auto max-h-[calc(100vh-50px)] pr-4 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200">
// // // //                     {filteredContent.length === 0 ? (
// // // //                       <div className="col-span-full text-center py-12 text-gray-500">
// // // //                         <p>Belum ada konten untuk kategori ini.</p>
// // // //                       </div>
// // // //                     ) : (
// // // //                       filteredContent.map((content) => (
// // // //                         <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/90 backdrop-blur-sm cursor-pointer" onClick={() => handleContentClick(content)}>
// // // //                           <div className="relative overflow-hidden">{renderContent(content)}</div>
// // // //                           <CardContent className="p-4">
// // // //                             <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
// // // //                               <span>{formatTimeAgo(content.created_at)}</span>
// // // //                               <div className="flex items-center space-x-3"><span className="flex items-center"><Eye className="w-3 h-3 mr-1" />{Math.floor(Math.random() * 1000)}</span></div>
// // // //                             </div>
// // // //                             <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</h4>
// // // //                             <div className="flex flex-wrap gap-1">{content.tags.slice(0, 2).map((tag) => (<Badge key={tag} variant="secondary" className="text-xs bg-gray-100/80">{tag}</Badge>))}</div>
// // // //                           </CardContent>
// // // //                         </Card>
// // // //                       ))
// // // //                     )}
// // // //                   </div>
// // // //                 </div>

// // // //                 <div className="lg:col-span-1">
// // // //                   <div className="sticky top-24 space-y-6">
// // // //                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
// // // //                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><TrendingUp className="w-5 h-5 mr-2 text-orange-500" /> Trending</CardTitle></CardHeader>
// // // //                       <CardContent className="space-y-4">
// // // //                         {trendingContent.map((content, index) => (
// // // //                           <div key={content.id} className="flex items-start space-x-3 group cursor-pointer" onClick={() => handleContentClick(content)}>
// // // //                             <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${index === 0 ? 'bg-yellow-500 text-white' : index === 1 ? 'bg-gray-400 text-white' : index === 2 ? 'bg-yellow-600 text-white' : 'bg-gray-200 text-gray-600'}`}>{index + 1}</div>
// // // //                             <div className="flex-1 min-w-0"><p className="text-sm font-medium line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</p><p className="text-xs text-gray-500 mt-1">{Math.floor(Math.random() * 500) + 100} views</p></div>
// // // //                           </div>
// // // //                         ))}
// // // //                       </CardContent>
// // // //                     </Card>
// // // //                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
// // // //                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><Star className="w-5 h-5 mr-2 text-blue-500" /> MPStore Resources</CardTitle></CardHeader>
// // // //                       <CardContent className="space-y-3">
// // // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://apps.apple.com/id/app/mpstore-superapp-umkm/id1514516462?mt=8', '_blank')}><Smartphone className="w-4 h-4 mr-2" /> Download App</Button>
// // // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.instagram.com/mpstore_superappumkm/', '_blank')}><Instagram className="w-4 h-4 mr-2" /> Instagram</Button>
// // // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.facebook.com/people/MPStore/100087175355298/', '_blank')}><Facebook className="w-4 h-4 mr-2" /> Facebook</Button>
// // // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667&text&type=phone_number&app_absent=0', '_blank')}><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp CS</Button>
// // // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}><Newspaper className="w-4 h-4 mr-2" /> News & Updates</Button>
// // // //                       </CardContent>
// // // //                     </Card>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             </>
// // // //           )}
// // // //         </main>

// // // //         <Footer />

// // // //         <div className="fixed bottom-6 right-6 z-50">
// // // //           <Button
// // // //             onClick={() => window.location.href = '/admin'}
// // // //             variant="outline"
// // // //             className="shadow-lg rounded-full h-12 w-12 p-0 bg-white"
// // // //           >
// // // //             <Settings className="w-6 h-6" />
// // // //           </Button>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default ModernHomepage;

// // // import React, { useState, useEffect, useMemo } from "react";
// // // import { Button } from "./ui/button.jsx";
// // // import { Input } from "./ui/input.jsx";
// // // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card.jsx";
// // // import { Badge } from "./ui/badge.jsx";
// // // import { Search, Video, FileText, Image, Instagram, Facebook, MessageCircle, Newspaper, Smartphone, ExternalLink, Sun, Moon, Play, Eye, Clock, TrendingUp, Star, Settings, X, BookOpen } from "lucide-react";
// // // import axios from "axios";
// // // import SplitText from "./SplitText.js";
// // // import Particles from "./Particles.js";
// // // import TextType from "./TextType.js";
// // // import CardNav from "./CardNav.js";
// // // import Footer from "./Footer.js";
// // // import CurvedLoop from "./CurvedLoop.js";
// // // import { Dialog, DialogContent } from "./ui/dialog.jsx";

// // // const ModernHomepage = () => {
// // //   const [query, setQuery] = useState("");
// // //   const [searchResult, setSearchResult] = useState(null);
// // //   const [loading, setLoading] = useState(false);
// // //   const [aiLoading, setAiLoading] = useState(false);
// // //   const [allTags, setAllTags] = useState([]);
// // //   const [allFetchedContent, setAllFetchedContent] = useState([]);

// // //   // HAPUS: State darkMode tidak lagi diperlukan
// // //   // const [darkMode, setDarkMode] = useState(false);

// // //   const [activeContentTab, setActiveContentTab] = useState('video');
// // //   const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
// // //   const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
// // //   const [currentPdfTitle, setCurrentPdfTitle] = useState("");

// // //   const handleAnimationComplete = () => {
// // //     console.log('Text animation completed!');
// // //   };

// // //   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // //   const API = `${BACKEND_URL}/api`;

// // //   const filteredContent = useMemo(() => {
// // //     if (!allFetchedContent || allFetchedContent.length === 0) return [];

// // //     switch (activeContentTab) {
// // //       case 'video':
// // //         return allFetchedContent.filter(c => c.content_type === 'video_youtube');

// // //       case 'buku tutorial':
// // //         return allFetchedContent.filter(c => c.content_type === 'file');

// // //       case 'konten':
// // //         return allFetchedContent.filter(c =>
// // //           ['instagram_reel', 'instagram_feed', 'video_tiktok'].includes(c.content_type)
// // //         );

// // //       default:
// // //         return allFetchedContent.filter(c => c.content_type === 'video_youtube');
// // //     }
// // //   }, [activeContentTab, allFetchedContent]);

// // //   const trendingContent = useMemo(() => {
// // //     return allFetchedContent.slice(0, 5);
// // //   }, [allFetchedContent]);

// // //   useEffect(() => {
// // //     fetchInitialData();

// // //     // --- LOGIKA LIGHT MODE PERMANEN ---
// // //     // 1. Paksa hapus class 'dark' dari elemen HTML
// // //     document.documentElement.classList.remove('dark');
// // //     // 2. Hapus preferensi tema yang mungkin tersimpan di browser user
// // //     localStorage.removeItem('theme');

// // //     const loadScript = (id, src) => {
// // //       if (!document.getElementById(id)) {
// // //         const script = document.createElement('script');
// // //         script.id = id;
// // //         script.src = src;
// // //         script.async = true;
// // //         document.body.appendChild(script);
// // //       }
// // //     };

// // //     loadScript('tiktok-embed-script', 'https://www.tiktok.com/embed.js');
// // //     loadScript('instagram-embed-script', '//www.instagram.com/embed.js');

// // //   }, []);

// // //   // HAPUS: useEffect untuk memantau embed instgrm saat konten berubah
// // //   // Kita gabungkan logika reload embed ke useEffect konten di bawah atau biarkan di sini jika terpisah
// // //   useEffect(() => {
// // //     const timer = setTimeout(() => {
// // //       if (window.instgrm) {
// // //         window.instgrm.Embeds.process();
// // //       }
// // //     }, 500);
// // //     return () => clearTimeout(timer);
// // //   }, [filteredContent, activeContentTab]);

// // //   const fetchInitialData = async () => {
// // //     try {
// // //       const tagsResponse = await axios.get(`${API}/search/tags`);
// // //       console.log(tagsResponse.data)
// // //       setAllTags(tagsResponse.data.slice(0, 12));

// // //       const contentTypes = ['video_youtube', 'file', 'instagram_reel', 'instagram_feed', 'video_tiktok'];

// // //       const responses = await Promise.all(
// // //         contentTypes.map(type => axios.get(`${API}/content/by-type/${type}`))
// // //       );

// // //       const allContent = [];
// // //       responses.forEach(response => {
// // //         if (response.data && Array.isArray(response.data.content)) {
// // //           allContent.push(...response.data.content);
// // //         }
// // //       });

// // //       const uniqueContent = Array.from(new Map(allContent.map(item => [item.id, item])).values());
// // //       const shuffled = uniqueContent.sort(() => 0.5 - Math.random());
// // //       setAllFetchedContent(shuffled);

// // //     } catch (error) {
// // //       console.error("Error fetching initial data:", error);
// // //     }
// // //   };

// // //   const getContentImage = (content) => {
// // //     if (content.content_type === 'image' && content.content_data.url) {
// // //       const separator = content.content_data.url.includes('?') ? '&' : '?';
// // //       return `${content.content_data.url}${separator}v=${Date.now()}`;
// // //     }
// // //     if (content.content_type === 'video_youtube') {
// // //       const embedUrl = content.content_data.embed_url;
// // //       const videoId = embedUrl?.match(/embed\/([^?]*)/)?.[1];
// // //       return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '/api/placeholder/600/300';
// // //     }
// // //     if (content.content_data.thumbnail_url) {
// // //       const separator = content.content_data.thumbnail_url.includes('?') ? '&' : '?';
// // //       return `${content.content_data.thumbnail_url}${separator}v=${Date.now()}`;
// // //     }
// // //     return '/api/placeholder/600/300';
// // //   };

// // //   const getContentLink = (content) => {
// // //     if (content.content_type === 'video_youtube') {
// // //       return content.content_data.embed_url?.replace('embed/', 'watch?v=');
// // //     }
// // //     if (content.content_type === 'video_upload' || content.content_type === 'video_tiktok') {
// // //       return content.content_data.original_url || content.content_data.url;
// // //     }
// // //     if (content.content_type.includes('instagram')) {
// // //       return content.content_data.original_url;
// // //     }
// // //     if (content.content_type === 'article') {
// // //       if (content.content_data.pdf_url) {
// // //         return content.content_data.pdf_url;
// // //       }
// // //       return `/article/${content.id}`;
// // //     }
// // //     if (content.content_type === 'file') {
// // //       return content.content_data.url;
// // //     }
// // //     if (content.content_type === 'image') {
// // //       return content.content_data.url;
// // //     }
// // //     return content.content_data.url || '#';
// // //   };

// // //   const handleSearch = async (searchQuery = query) => {
// // //     if (!searchQuery.trim()) return;
// // //     setLoading(true);
// // //     try {
// // //       const localResponse = await axios.post(`${API}/search/content`, { query: searchQuery });
// // //       const localResults = [...(localResponse.data.related_videos || []), ...(localResponse.data.related_content || [])];
// // //       setSearchResult({
// // //         query: searchQuery,
// // //         local_results: localResults,
// // //         ai_response: null,
// // //         ai_loading: true
// // //       });
// // //       setAiLoading(true);
// // //       const aiResponse = await axios.post(`${API}/search/ai`, { query: searchQuery });
// // //       setSearchResult(prev => ({ ...prev, ai_response: aiResponse.data.ai_response, ai_loading: false }));
// // //     } catch (error) {
// // //       console.error("Search error:", error);
// // //     } finally {
// // //       setLoading(false);
// // //       setAiLoading(false);
// // //     }
// // //   };

// // //   const handleKeyPress = (e) => {
// // //     if (e.key === 'Enter') {
// // //       handleSearch();
// // //     }
// // //   };

// // //   const handleTagClick = (tag) => {
// // //     setQuery(tag);
// // //     handleSearch(tag);
// // //   };

// // //   const formatTimeAgo = (dateString) => {
// // //     const date = new Date(dateString);
// // //     const now = new Date();
// // //     const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
// // //     if (diffInHours < 1) return 'Baru saja';
// // //     if (diffInHours < 24) return `${diffInHours} jam yang lalu`;
// // //     const diffInDays = Math.floor(diffInHours / 24);
// // //     if (diffInDays < 7) return `${diffInDays} hari yang lalu`;
// // //     return date.toLocaleDateString('id-ID');
// // //   };

// // //   const handleDownloadPdf = async () => {
// // //     try {
// // //       const downloadUrl = `${API}/download-pdf?url=${encodeURIComponent(currentPdfUrl)}&filename=${encodeURIComponent(currentPdfTitle + '.pdf')}`;

// // //       const link = document.createElement('a');
// // //       link.href = downloadUrl;
// // //       link.download = currentPdfTitle + '.pdf';
// // //       document.body.appendChild(link);
// // //       link.click();
// // //       document.body.removeChild(link);
// // //     } catch (error) {
// // //       console.error('Download error:', error);
// // //       const link = document.createElement('a');
// // //       link.href = currentPdfUrl;
// // //       link.download = currentPdfTitle + '.pdf';
// // //       link.target = '_blank';
// // //       document.body.appendChild(link);
// // //       link.click();
// // //       document.body.removeChild(link);
// // //     }
// // //   };

// // //   const handleContentClick = (content) => {
// // //     if (content.content_data.embed_code || content.content_data.embed_html) return;

// // //     if (content.content_type === 'file' && content.content_data.url && content.content_data.url.toLowerCase().endsWith('.pdf')) {
// // //       setCurrentPdfUrl(content.content_data.url);
// // //       setCurrentPdfTitle(content.title);
// // //       setPdfViewerOpen(true);
// // //       return;
// // //     }

// // //     if (content.content_type === 'article' && content.content_data.pdf_url) {
// // //       setCurrentPdfUrl(content.content_data.pdf_url);
// // //       setCurrentPdfTitle(content.title);
// // //       setPdfViewerOpen(true);
// // //       return;
// // //     }

// // //     const contentLink = getContentLink(content);
// // //     if (contentLink !== '#') {
// // //       window.open(contentLink, '_blank');
// // //     }
// // //   };

// // //   const closePdfViewer = () => {
// // //     setPdfViewerOpen(false);
// // //     setCurrentPdfUrl(null);
// // //     setCurrentPdfTitle("");
// // //   };

// // //   const renderContent = (content) => {
// // //     switch (content.content_type) {
// // //       case 'video_youtube':
// // //         return (
// // //           <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden group">
// // //             {content.content_data.embed_url ? (
// // //               <iframe
// // //                 src={content.content_data.embed_url}
// // //                 title={content.title}
// // //                 className="w-full h-full rounded-lg"
// // //                 allowFullScreen
// // //                 frameBorder="0"
// // //               />
// // //             ) : (
// // //               <img src={getContentImage(content)} alt={content.title} className="w-full h-full object-cover" />
// // //             )}
// // //             <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
// // //               <Video className="w-3 h-3 inline mr-1" /> Video
// // //             </div>
// // //           </div>
// // //         );
// // //       case 'video_tiktok':
// // //         return (
// // //           <div className="flex justify-center items-center bg-transparent rounded-lg">
// // //             {content.content_data.embed_html ? (
// // //               <div className="w-full [&>blockquote]:m-0 [&>blockquote]:mx-auto" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
// // //             ) : (
// // //               <a href={content.content_data.original_url} target="_blank" rel="noopener noreferrer" className="text-white bg-black rounded p-4 block">Lihat di TikTok</a>
// // //             )}
// // //           </div>
// // //         );
// // //       case 'video_upload':
// // //         return (
// // //           <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden group cursor-pointer" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || '16/9' }} onClick={() => handleContentClick(content)}>
// // //             {content.content_data.url ? (
// // //               <video controls playsInline className="w-full h-full rounded-lg object-cover"><source src={content.content_data.url} type="video/mp4" /></video>
// // //             ) : <div className="flex items-center justify-center h-full text-gray-400"><Video className="w-8 h-8" /></div>}
// // //             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Video className="w-3 h-3 inline mr-1" /> Video Upload</div>
// // //           </div>
// // //         );
// // //       case 'instagram_reel':
// // //       case 'instagram_feed':
// // //         if (content.content_data.embed_code) {
// // //           return (
// // //             <div className="flex justify-center w-full bg-white dark:bg-gray-900 rounded-lg overflow-hidden p-2">
// // //               <div className="instagram-embed-wrapper w-full flex justify-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
// // //             </div>
// // //           );
// // //         }
// // //         return (
// // //           <div className="relative bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || (content.content_type === 'instagram_reel' ? '9/16' : '1/1'), minHeight: '300px' }} onClick={() => handleContentClick(content)}>
// // //             {content.content_data.thumbnail_url ? <img src={content.content_data.thumbnail_url} alt={content.title} className="w-full h-full object-cover" /> : <div className="flex items-center justify-center h-full text-white"><Instagram className="w-8 h-8" /></div>}
// // //             <div className="absolute bottom-2 left-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs px-2 py-1 rounded"><Instagram className="w-3 h-3 inline mr-1" /> {content.content_type === 'instagram_reel' ? 'Reel' : 'Post'}</div>
// // //           </div>
// // //         );
// // //       case 'image':
// // //         return (
// // //           <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || 'auto' }} onClick={() => handleContentClick(content)}>
// // //             <img src={content.content_data.url} alt={content.title} className="w-full h-full object-cover" onError={(e) => { e.target.src = '/api/placeholder/600/300'; }} />
// // //             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Image className="w-3 h-3 inline mr-1" /> Gambar</div>
// // //           </div>
// // //         );
// // //       case 'article':
// // //         if (content.content_data.pdf_url) {
// // //           return (
// // //             <div className="relative aspect-video bg-gradient-to-br from-red-100 to-orange-100 dark:from-red-900 dark:to-orange-900 rounded-lg overflow-hidden cursor-pointer group" onClick={() => handleContentClick(content)}>
// // //               <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
// // //                 <FileText className="w-12 h-12 mb-3 text-red-600 dark:text-red-400" />
// // //                 <p className="text-sm font-semibold text-center mb-2 text-gray-800 dark:text-gray-200">{content.title}</p>
// // //                 <Badge className="bg-red-500 text-white">PDF Tutorial</Badge>
// // //               </div>
// // //               <div className="absolute inset-0 bg-red-500 opacity-0 group-hover:opacity-10 transition-opacity"></div>
// // //             </div>
// // //           );
// // //         }
// // //         return (
// // //           <div className="aspect-video bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900 dark:to-purple-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
// // //             <div className="text-center">
// // //               <FileText className="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" />
// // //               <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-3">{content.content_data.text?.substring(0, 100)}...</p>
// // //             </div>
// // //           </div>
// // //         );
// // //       case 'file':
// // //         const isPdf = content.content_data?.url?.toLowerCase().endsWith('.pdf');
// // //         const coverImage = content.content_data?.cover_image_url;

// // //         // JIKA ADA COVER IMAGE
// // //         if (coverImage) {
// // //           return (
// // //             <div
// // //               className="relative aspect-video rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02] bg-cover bg-center"
// // //               style={{ backgroundImage: `url(${coverImage})` }}
// // //               onClick={() => handleContentClick(content)}
// // //             >
// // //               <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors"></div>

// // //               <div className="relative z-10 flex flex-col items-center">
// // //                 <BookOpen className="w-12 h-12 mb-2 opacity-90 drop-shadow-md" />
// // //                 <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2 drop-shadow-md px-2">{content.title}</p>
// // //                 <p className="text-[9px] opacity-90 text-center mt-1 bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded-full">Klik untuk membaca</p>
// // //               </div>

// // //               {isPdf && (
// // //                 <div className="absolute top-2 right-2 bg-red-600 shadow-md text-white text-[9px] font-bold px-1.5 py-0.5 rounded z-10">PDF</div>
// // //               )}
// // //             </div>
// // //           );
// // //         }

// // //         // DEFAULT FALLBACK (JIKA TIDAK ADA COVER IMAGE)
// // //         if (isPdf) {
// // //           return (
// // //             <div className="relative aspect-video bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02]" onClick={() => handleContentClick(content)}>
// // //               <BookOpen className="w-12 h-12 mb-2 opacity-90" />
// // //               <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2">{content.title}</p>
// // //               <p className="text-[9px] opacity-75 text-center mt-1 bg-white/20 px-2 py-0.5 rounded-full">Klik untuk membaca</p>
// // //               <div className="absolute top-2 right-2 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">PDF</div>
// // //             </div>
// // //           );
// // //         }
// // //         return (
// // //           <div className="aspect-video bg-gradient-to-br from-green-100 to-blue-100 dark:from-green-900 dark:to-blue-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
// // //             <div className="text-center">
// // //               <FileText className="w-8 h-8 mx-auto mb-2 text-green-600 dark:text-green-400" />
// // //               <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">{content.content_data.file_name || 'File'}</p>
// // //               <Button className="bg-green-600 text-white hover:bg-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300" size="sm"><ExternalLink className="w-4 h-4 mr-2" /> Download File</Button>
// // //             </div>
// // //           </div>
// // //         );
// // //       default:
// // //         return <div className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center"><FileText className="w-8 h-8 text-gray-400" /></div>;
// // //     }
// // //   };

// // //   // PENTING: Gunakan useMemo untuk array warna partikel agar tidak direferensikan ulang setiap render
// // //   // Ini mencegah Particles component re-render yang menyebabkan "flicker/gerak"
// // //   const particleColors = useMemo(() =>
// // //     ['#1e1e1e', '#3b82f6', '#1d4ed8'],
// // //     [] // Empty dependency array karena warna statis untuk light mode
// // //   );

// // //   const navItems = [
// // //     {
// // //       label: "Tentang",
// // //       bgColor: "#0D0716",
// // //       textColor: "#fff",
// // //       links: [
// // //         { label: "Perusahaan", ariaLabel: "Tentang Perusahaan", href: "https://mpstore.co.id/about" },
// // //         { label: "Karir", ariaLabel: "Karir", href: "https://mpstore.co.id/career" }
// // //       ]
// // //     },
// // //     {
// // //       label: "Layanan",
// // //       bgColor: "#170D27",
// // //       textColor: "#fff",
// // //       links: [
// // //         { label: "QRIS", ariaLabel: "QRIS", href: "https://mpstore.co.id/apps" },
// // //         { label: "Agen Pulsa & PPOB", ariaLabel: "Agen Pulsa & PPOB", href: "#" },
// // //         { label: "Kulakan Indomarco", ariaLabel: "Kulakan Indomarco", href: "#" },
// // //         { label: "Logistik Kasir", ariaLabel: "Logistik Kasir", href: "#" },
// // //         { label: "Akses Permodalan", ariaLabel: "Akses Permodalan", href: "#" },
// // //         { label: "Miniweb", ariaLabel: "Miniweb", href: "#" }
// // //       ]
// // //     },
// // //     {
// // //       label: "Bantuan",
// // //       bgColor: "#271E37",
// // //       textColor: "#fff",
// // //       links: [
// // //         { label: "WhatsApp CS", ariaLabel: "Hubungi CS", href: "https://api.whatsapp.com/send/?phone=6285812626667" },
// // //         { label: "Email", ariaLabel: "Email Kami", href: "mailto:support@mpstore.co.id" },
// // //         { label: "FAQ", ariaLabel: "Tanya Jawab", href: "#" }
// // //       ]
// // //     }
// // //   ];

// // //   return (
// // //     // CLASS 'dark' DIHAPUS DARI SINI. Hanya pakai class biasa.
// // //     <div className="min-h-screen transition-colors duration-300 relative text-gray-900">

// // //       <Particles
// // //         particleColors={particleColors}
// // //         particleCount={200}
// // //         particleSpread={10}
// // //         speed={0.1}
// // //         particleBaseSize={100}
// // //         moveParticlesOnHover={true}
// // //         alphaParticles={false}
// // //         disableRotation={false}
// // //         className="fixed inset-0 w-full h-full"
// // //       />

// // //       {/* PDF Viewer Modal */}
// // //       {pdfViewerOpen && (
// // //         <Dialog open={pdfViewerOpen} onOpenChange={setPdfViewerOpen}>
// // //           <DialogContent className="max-w-5xl w-[95vw] h-[90vh] p-0 overflow-hidden bg-zinc-900 border-zinc-800">
// // //             <div className="flex flex-col h-full">
// // //               <div className="flex items-center justify-between p-4 bg-zinc-900 text-white border-b border-zinc-800">
// // //                 <h3 className="font-medium truncate flex items-center gap-2">
// // //                   <BookOpen className="w-5 h-5 text-blue-400" />
// // //                   {currentPdfTitle || "Document Viewer"}
// // //                 </h3>
// // //                 <div className="flex items-center gap-2">
// // //                   <button
// // //                     onClick={handleDownloadPdf}
// // //                     className="text-xs bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
// // //                   >
// // //                     <ExternalLink className="w-3 h-3 mr-1" /> Download
// // //                   </button>
// // //                   <a
// // //                     href={currentPdfUrl}
// // //                     target="_blank"
// // //                     rel="noreferrer"
// // //                     className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
// // //                   >
// // //                     <ExternalLink className="w-3 h-3 mr-1" /> Buka Full
// // //                   </a>
// // //                   <button onClick={() => setPdfViewerOpen(false)} className="text-zinc-400 hover:text-white">
// // //                     <X className="w-6 h-6" />
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //               <div className="flex-1 bg-zinc-800 relative">
// // //                 {currentPdfUrl ? (
// // //                   <iframe
// // //                     src={`${currentPdfUrl}#toolbar=0&view=FitH`}
// // //                     title="PDF Viewer"
// // //                     className="w-full h-full absolute inset-0 border-0"
// // //                   />
// // //                 ) : (
// // //                   <div className="flex items-center justify-center h-full text-zinc-500">
// // //                     Memuat Dokumen...
// // //                   </div>
// // //                 )}
// // //               </div>
// // //             </div>
// // //           </DialogContent>
// // //         </Dialog>
// // //       )}

// // //       <div className="relative z-10 flex flex-col min-h-screen">
// // //         <CardNav
// // //           logo="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
// // //           logoAlt="MPStore Logo"
// // //           items={navItems}
// // //           // HARDCODE WARNA LIGHT MODE
// // //           baseColor="rgba(255, 255, 255, 0.8)"
// // //           menuColor="#000"
// // //           buttonBgColor="#2563eb"
// // //           buttonTextColor="#fff"
// // //           ease="power3.out"
// // //         />

// // //         <main className="container mx-auto px-4 py-8 pt-32 flex-grow">

// // //           <div className="mb-8 w-full flex flex-col items-center text-center gap-6">
// // //             <div className="w-full overflow-hidden mt-8">
// // //               <SplitText
// // //                 text="Selamat Datang di MPStore Training Center"
// // //                 className="text-4xl md:text-5xl font-bold text-center text-blue-600 pb-2 drop-shadow-md"
// // //                 delay={50}
// // //                 duration={1}
// // //                 ease="back.out(1.7)"
// // //                 threshold={0.1}
// // //                 rootMargin="-50px"
// // //                 onLetterAnimationComplete={handleAnimationComplete}
// // //               />
// // //             </div>

// // //             <div className="min-h-[40px]">
// // //               <TextType
// // //                 text={[
// // //                   "Belajar fitur-fitur MPStore dengan mudah",
// // //                   "Tutorial lengkap untuk kembangkan bisnismu",
// // //                   "Kelola usaha jadi lebih efisien!"
// // //                 ]}
// // //                 className="text-lg md:text-xl text-gray-600 font-medium"
// // //                 typingSpeed={50}
// // //                 pauseDuration={2000}
// // //                 deletingSpeed={30}
// // //                 cursorCharacter="|"
// // //                 cursorClassName="text-blue-500 font-bold"
// // //               />
// // //             </div>

// // //             <div className="w-full max-w-2xl mx-auto mt-4">
// // //               <div className="relative group">
// // //                 <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 blur"></div>
// // //                 <div className="relative flex bg-white rounded-full p-1">
// // //                   <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// // //                   <Input
// // //                     type="text"
// // //                     placeholder="Cari tutorial, tips, atau tanyakan apapun..."
// // //                     value={query}
// // //                     onChange={(e) => setQuery(e.target.value)}
// // //                     onKeyPress={handleKeyPress}
// // //                     className="pl-12 pr-4 py-6 w-full bg-transparent border-0 focus:ring-0 focus-visible:ring-0 rounded-full text-lg"
// // //                   />
// // //                   {query && (
// // //                     <Button
// // //                       onClick={() => handleSearch()}
// // //                       disabled={loading}
// // //                       className="rounded-full px-8 bg-blue-600 hover:bg-blue-700 text-white"
// // //                     >
// // //                       {loading ? '...' : 'Cari'}
// // //                     </Button>
// // //                   )}
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>

// // //           {searchResult && (
// // //             <section className="mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
// // //               <div className="max-w-4xl mx-auto space-y-8">
// // //                 <div className="text-center">
// // //                   <h2 className="text-3xl font-bold mb-4">
// // //                     Hasil pencarian: "{searchResult.query}"
// // //                   </h2>
// // //                   <Button variant="outline" onClick={() => setSearchResult(null)} className="rounded-full">
// // //                     ← Kembali ke Beranda
// // //                   </Button>
// // //                 </div>

// // //                 <Card className="bg-white/90 backdrop-blur-sm border-l-4 border-blue-500 shadow-lg">
// // //                   <CardHeader>
// // //                     <CardTitle className="flex items-center gap-2">
// // //                       <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
// // //                         <span className="text-white text-sm font-bold">AI</span>
// // //                       </div>
// // //                       Jawaban AI
// // //                     </CardTitle>
// // //                   </CardHeader>
// // //                   <CardContent>
// // //                     {searchResult.ai_loading ? (
// // //                       <div className="flex items-center gap-2">
// // //                         <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
// // //                         <span className="text-gray-600">Sedang menganalisis...</span>
// // //                       </div>
// // //                     ) : searchResult.ai_response ? (
// // //                       <div className="prose prose-sm max-w-none">
// // //                         <p className="whitespace-pre-wrap">{searchResult.ai_response}</p>
// // //                       </div>
// // //                     ) : (
// // //                       <p className="text-gray-500">Tidak ada respons AI yang tersedia.</p>
// // //                     )}
// // //                   </CardContent>
// // //                 </Card>

// // //                 {searchResult.local_results && searchResult.local_results.length > 0 && (
// // //                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
// // //                     {searchResult.local_results.map((content) => (
// // //                       <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/80 backdrop-blur-sm overflow-hidden cursor-pointer" onClick={() => handleContentClick(content)}>
// // //                         <div className="relative">{renderContent(content)}</div>
// // //                         <CardContent className="p-4">
// // //                           <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
// // //                             <span>{formatTimeAgo(content.created_at)}</span>
// // //                           </div>
// // //                           <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
// // //                             {content.title}
// // //                           </h4>
// // //                         </CardContent>
// // //                       </Card>
// // //                     ))}
// // //                   </div>
// // //                 )}
// // //               </div>
// // //             </section>
// // //           )}

// // //           {!searchResult && (
// // //             <>
// // //               <section className="mb-8 mt-12">
// // //                 <h3 className="text-2xl font-bold mb-6 text-center">Kategori Populer</h3>
// // //                 <div className="flex flex-wrap justify-center gap-3">
// // //                   {allTags.map((tag) => (
// // //                     <Button key={tag} variant="outline" onClick={() => handleTagClick(tag)} className="rounded-full bg-white/50 hover:bg-blue-50 border-gray-300 backdrop-blur-sm">
// // //                       {tag}
// // //                     </Button>
// // //                   ))}
// // //                 </div>
// // //               </section>

// // //               <div className="mb-1">
// // //                 <CurvedLoop
// // //                   marqueeText="Kasir | Qris | Akses Permodalan | Mini Website | Agen Pulsa & PPOB | Kulakan Indomarco | Logistik"
// // //                   speed={2}
// // //                   curveAmount={0}
// // //                   className="text-grey-600"
// // //                 />
// // //               </div>

// // //               <section className="mb-8">
// // //                 <div className="flex space-x-1 mb-6 bg-gray-100/80 p-1 rounded-full max-w-md backdrop-blur-sm mx-auto">
// // //                   {[
// // //                     { id: 'video', label: 'Video' },
// // //                     { id: 'buku tutorial', label: 'Buku Tutorial' },
// // //                     { id: 'konten', label: 'Konten' }
// // //                   ].map((tab) => (
// // //                     <Button
// // //                       key={tab.id}
// // //                       variant={activeContentTab === tab.id ? "default" : "ghost"}
// // //                       size="sm"
// // //                       onClick={() => setActiveContentTab(tab.id)}
// // //                       className={`flex-1 rounded-full transition-all ${activeContentTab === tab.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
// // //                     >
// // //                       {tab.label}
// // //                     </Button>
// // //                   ))}
// // //                 </div>
// // //               </section>

// // //               <div className="grid lg:grid-cols-4 gap-8">
// // //                 <div className="lg:col-span-3">
// // //                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-y-auto max-h-[calc(100vh-50px)] pr-4 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200">
// // //                     {filteredContent.length === 0 ? (
// // //                       <div className="col-span-full text-center py-12 text-gray-500">
// // //                         <p>Belum ada konten untuk kategori ini.</p>
// // //                       </div>
// // //                     ) : (
// // //                       filteredContent.map((content) => (
// // //                         <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/90 backdrop-blur-sm cursor-pointer" onClick={() => handleContentClick(content)}>
// // //                           <div className="relative overflow-hidden">{renderContent(content)}</div>
// // //                           <CardContent className="p-4">
// // //                             <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
// // //                               <span>{formatTimeAgo(content.created_at)}</span>
// // //                               <div className="flex items-center space-x-3"><span className="flex items-center"><Eye className="w-3 h-3 mr-1" />{Math.floor(Math.random() * 1000)}</span></div>
// // //                             </div>
// // //                             <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</h4>
// // //                             <div className="flex flex-wrap gap-1">{content.tags.slice(0, 2).map((tag) => (<Badge key={tag} variant="secondary" className="text-xs bg-gray-100/80">{tag}</Badge>))}</div>
// // //                           </CardContent>
// // //                         </Card>
// // //                       ))
// // //                     )}
// // //                   </div>
// // //                 </div>

// // //                 <div className="lg:col-span-1">
// // //                   <div className="sticky top-24 space-y-6">
// // //                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
// // //                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><TrendingUp className="w-5 h-5 mr-2 text-orange-500" /> Trending</CardTitle></CardHeader>
// // //                       <CardContent className="space-y-4">
// // //                         {trendingContent.map((content, index) => (
// // //                           <div key={content.id} className="flex items-start space-x-3 group cursor-pointer" onClick={() => handleContentClick(content)}>
// // //                             <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${index === 0 ? 'bg-yellow-500 text-white' : index === 1 ? 'bg-gray-400 text-white' : index === 2 ? 'bg-yellow-600 text-white' : 'bg-gray-200 text-gray-600'}`}>{index + 1}</div>
// // //                             <div className="flex-1 min-w-0"><p className="text-sm font-medium line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</p><p className="text-xs text-gray-500 mt-1">{Math.floor(Math.random() * 500) + 100} views</p></div>
// // //                           </div>
// // //                         ))}
// // //                       </CardContent>
// // //                     </Card>
// // //                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
// // //                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><Star className="w-5 h-5 mr-2 text-blue-500" /> MPStore Resources</CardTitle></CardHeader>
// // //                       <CardContent className="space-y-3">
// // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://apps.apple.com/id/app/mpstore-superapp-umkm/id1514516462?mt=8', '_blank')}><Smartphone className="w-4 h-4 mr-2" /> Download App</Button>
// // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.instagram.com/mpstore_superappumkm/', '_blank')}><Instagram className="w-4 h-4 mr-2" /> Instagram</Button>
// // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.facebook.com/people/MPStore/100087175355298/', '_blank')}><Facebook className="w-4 h-4 mr-2" /> Facebook</Button>
// // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667&text&type=phone_number&app_absent=0', '_blank')}><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp CS</Button>
// // //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}><Newspaper className="w-4 h-4 mr-2" /> News & Updates</Button>
// // //                       </CardContent>
// // //                     </Card>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </>
// // //           )}
// // //         </main>

// // //         <Footer />

// // //         <div className="fixed bottom-6 right-6 z-50">
// // //           <Button
// // //             onClick={() => window.location.href = '/admin'}
// // //             variant="outline"
// // //             className="shadow-lg rounded-full h-12 w-12 p-0 bg-white"
// // //           >
// // //             <Settings className="w-6 h-6" />
// // //           </Button>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default ModernHomepage;

// // import React, { useState, useEffect, useMemo } from "react";
// // import { Button } from "./ui/button.jsx";
// // import { Input } from "./ui/input.jsx";
// // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card.jsx";
// // import { Badge } from "./ui/badge.jsx";
// // import { Search, Video, FileText, Image, Instagram, Facebook, MessageCircle, Newspaper, Smartphone, ExternalLink, Sun, Moon, Play, Eye, Clock, TrendingUp, Star, Settings, X, BookOpen } from "lucide-react";
// // import axios from "axios";
// // import SplitText from "./SplitText.js";
// // import Particles from "./Particles.js";
// // import TextType from "./TextType.js";
// // import CardNav from "./CardNav.js";
// // import Footer from "./Footer.js";
// // import CurvedLoop from "./CurvedLoop.js";
// // import { Dialog, DialogContent } from "./ui/dialog.jsx";

// // const ModernHomepage = () => {
// //   const [query, setQuery] = useState("");
// //   const [searchResult, setSearchResult] = useState(null);
// //   const [loading, setLoading] = useState(false);
// //   const [aiLoading, setAiLoading] = useState(false);
// //   const [allTags, setAllTags] = useState([]);
// //   const [allFetchedContent, setAllFetchedContent] = useState([]);

// //   // HAPUS: State darkMode tidak lagi diperlukan
// //   // const [darkMode, setDarkMode] = useState(false);

// //   const [activeContentTab, setActiveContentTab] = useState('video');
// //   const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
// //   const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
// //   const [currentPdfTitle, setCurrentPdfTitle] = useState("");

// //   const handleAnimationComplete = () => {
// //     console.log('Text animation completed!');
// //   };

// //   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// //   const API = `${BACKEND_URL}/api`;

// //   const filteredContent = useMemo(() => {
// //     if (!allFetchedContent || allFetchedContent.length === 0) return [];

// //     switch (activeContentTab) {
// //       case 'video':
// //         return allFetchedContent.filter(c => c.content_type === 'video_youtube');

// //       case 'buku tutorial':
// //         return allFetchedContent.filter(c => c.content_type === 'file');

// //       case 'konten':
// //         return allFetchedContent.filter(c =>
// //           ['instagram_reel', 'instagram_feed', 'video_tiktok'].includes(c.content_type)
// //         );

// //       default:
// //         return allFetchedContent.filter(c => c.content_type === 'video_youtube');
// //     }
// //   }, [activeContentTab, allFetchedContent]);

// //   const trendingContent = useMemo(() => {
// //     return allFetchedContent.slice(0, 5);
// //   }, [allFetchedContent]);

// //   useEffect(() => {
// //     fetchInitialData();

// //     // --- LOGIKA LIGHT MODE PERMANEN ---
// //     // 1. Paksa hapus class 'dark' dari elemen HTML
// //     document.documentElement.classList.remove('dark');
// //     // 2. Hapus preferensi tema yang mungkin tersimpan di browser user
// //     localStorage.removeItem('theme');

// //     const loadScript = (id, src) => {
// //       if (!document.getElementById(id)) {
// //         const script = document.createElement('script');
// //         script.id = id;
// //         script.src = src;
// //         script.async = true;
// //         document.body.appendChild(script);
// //       }
// //     };

// //     loadScript('tiktok-embed-script', 'https://www.tiktok.com/embed.js');
// //     loadScript('instagram-embed-script', '//www.instagram.com/embed.js');

// //   }, []);

// //   // HAPUS: useEffect untuk memantau embed instgrm saat konten berubah
// //   // Kita gabungkan logika reload embed ke useEffect konten di bawah atau biarkan di sini jika terpisah
// //   useEffect(() => {
// //     const timer = setTimeout(() => {
// //       if (window.instgrm) {
// //         window.instgrm.Embeds.process();
// //       }
// //     }, 500);
// //     return () => clearTimeout(timer);
// //   }, [filteredContent, activeContentTab]);

// //   const fetchInitialData = async () => {
// //     try {
// //       const tagsResponse = await axios.get(`${API}/search/tags`);
// //       console.log(tagsResponse.data)
// //       setAllTags(tagsResponse.data.slice(0, 12));

// //       const contentTypes = ['video_youtube', 'file', 'instagram_reel', 'instagram_feed', 'video_tiktok'];

// //       const responses = await Promise.all(
// //         contentTypes.map(type => axios.get(`${API}/content/by-type/${type}`))
// //       );

// //       const allContent = [];
// //       responses.forEach(response => {
// //         if (response.data && Array.isArray(response.data.content)) {
// //           allContent.push(...response.data.content);
// //         }
// //       });

// //       const uniqueContent = Array.from(new Map(allContent.map(item => [item.id, item])).values());
// //       const shuffled = uniqueContent.sort(() => 0.5 - Math.random());
// //       setAllFetchedContent(shuffled);

// //     } catch (error) {
// //       console.error("Error fetching initial data:", error);
// //     }
// //   };

// //   const getContentImage = (content) => {
// //     if (content.content_type === 'image' && content.content_data.url) {
// //       const separator = content.content_data.url.includes('?') ? '&' : '?';
// //       return `${content.content_data.url}${separator}v=${Date.now()}`;
// //     }
// //     if (content.content_type === 'video_youtube') {
// //       const embedUrl = content.content_data.embed_url;
// //       const videoId = embedUrl?.match(/embed\/([^?]*)/)?.[1];
// //       return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '/api/placeholder/600/300';
// //     }
// //     if (content.content_data.thumbnail_url) {
// //       const separator = content.content_data.thumbnail_url.includes('?') ? '&' : '?';
// //       return `${content.content_data.thumbnail_url}${separator}v=${Date.now()}`;
// //     }
// //     return '/api/placeholder/600/300';
// //   };

// //   const getContentLink = (content) => {
// //     if (content.content_type === 'video_youtube') {
// //       return content.content_data.embed_url?.replace('embed/', 'watch?v=');
// //     }
// //     if (content.content_type === 'video_upload' || content.content_type === 'video_tiktok') {
// //       return content.content_data.original_url || content.content_data.url;
// //     }
// //     if (content.content_type.includes('instagram')) {
// //       return content.content_data.original_url;
// //     }
// //     if (content.content_type === 'article') {
// //       if (content.content_data.pdf_url) {
// //         return content.content_data.pdf_url;
// //       }
// //       return `/article/${content.id}`;
// //     }
// //     if (content.content_type === 'file') {
// //       return content.content_data.url;
// //     }
// //     if (content.content_type === 'image') {
// //       return content.content_data.url;
// //     }
// //     return content.content_data.url || '#';
// //   };

// //   const handleSearch = async (searchQuery = query) => {
// //     if (!searchQuery.trim()) return;
// //     setLoading(true);
// //     try {
// //       const localResponse = await axios.post(`${API}/search/content`, { query: searchQuery });
// //       const localResults = [...(localResponse.data.related_videos || []), ...(localResponse.data.related_content || [])];
// //       setSearchResult({
// //         query: searchQuery,
// //         local_results: localResults,
// //         ai_response: null,
// //         ai_loading: true
// //       });
// //       setAiLoading(true);
// //       const aiResponse = await axios.post(`${API}/search/ai`, { query: searchQuery });
// //       setSearchResult(prev => ({ ...prev, ai_response: aiResponse.data.ai_response, ai_loading: false }));
// //     } catch (error) {
// //       console.error("Search error:", error);
// //     } finally {
// //       setLoading(false);
// //       setAiLoading(false);
// //     }
// //   };

// //   const handleKeyPress = (e) => {
// //     if (e.key === 'Enter') {
// //       handleSearch();
// //     }
// //   };

// //   const handleTagClick = (tag) => {
// //     setQuery(tag);
// //     handleSearch(tag);
// //   };

// //   const formatTimeAgo = (dateString) => {
// //     const date = new Date(dateString);
// //     const now = new Date();
// //     const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
// //     if (diffInHours < 1) return 'Baru saja';
// //     if (diffInHours < 24) return `${diffInHours} jam yang lalu`;
// //     const diffInDays = Math.floor(diffInHours / 24);
// //     if (diffInDays < 7) return `${diffInDays} hari yang lalu`;
// //     return date.toLocaleDateString('id-ID');
// //   };

// //   const handleDownloadPdf = async () => {
// //     try {
// //       const downloadUrl = `${API}/download-pdf?url=${encodeURIComponent(currentPdfUrl)}&filename=${encodeURIComponent(currentPdfTitle + '.pdf')}`;

// //       const link = document.createElement('a');
// //       link.href = downloadUrl;
// //       link.download = currentPdfTitle + '.pdf';
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
// //     } catch (error) {
// //       console.error('Download error:', error);
// //       const link = document.createElement('a');
// //       link.href = currentPdfUrl;
// //       link.download = currentPdfTitle + '.pdf';
// //       link.target = '_blank';
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
// //     }
// //   };

// //   const handleContentClick = (content) => {
// //     if (content.content_data.embed_code || content.content_data.embed_html) return;

// //     if (content.content_type === 'file' && content.content_data.url && content.content_data.url.toLowerCase().endsWith('.pdf')) {
// //       setCurrentPdfUrl(content.content_data.url);
// //       setCurrentPdfTitle(content.title);
// //       setPdfViewerOpen(true);
// //       return;
// //     }

// //     if (content.content_type === 'article' && content.content_data.pdf_url) {
// //       setCurrentPdfUrl(content.content_data.pdf_url);
// //       setCurrentPdfTitle(content.title);
// //       setPdfViewerOpen(true);
// //       return;
// //     }

// //     const contentLink = getContentLink(content);
// //     if (contentLink !== '#') {
// //       window.open(contentLink, '_blank');
// //     }
// //   };

// //   const closePdfViewer = () => {
// //     setPdfViewerOpen(false);
// //     setCurrentPdfUrl(null);
// //     setCurrentPdfTitle("");
// //   };

// //   const renderContent = (content) => {
// //     switch (content.content_type) {
// //       case 'video_youtube':
// //         return (
// //           <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden group">
// //             {content.content_data.embed_url ? (
// //               <iframe
// //                 src={content.content_data.embed_url}
// //                 title={content.title}
// //                 className="w-full h-full rounded-lg"
// //                 allowFullScreen
// //                 frameBorder="0"
// //               />
// //             ) : (
// //               <img src={getContentImage(content)} alt={content.title} className="w-full h-full object-cover" />
// //             )}
// //             <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
// //               <Video className="w-3 h-3 inline mr-1" /> Video
// //             </div>
// //           </div>
// //         );
// //       case 'video_tiktok':
// //         return (
// //           <div className="flex justify-center items-center bg-transparent rounded-lg">
// //             {content.content_data.embed_html ? (
// //               <div className="w-full [&>blockquote]:m-0 [&>blockquote]:mx-auto" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
// //             ) : (
// //               <a href={content.content_data.original_url} target="_blank" rel="noopener noreferrer" className="text-white bg-black rounded p-4 block">Lihat di TikTok</a>
// //             )}
// //           </div>
// //         );
// //       case 'video_upload':
// //         return (
// //           <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden group cursor-pointer" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || '16/9' }} onClick={() => handleContentClick(content)}>
// //             {content.content_data.url ? (
// //               <video controls playsInline className="w-full h-full rounded-lg object-cover"><source src={content.content_data.url} type="video/mp4" /></video>
// //             ) : <div className="flex items-center justify-center h-full text-gray-400"><Video className="w-8 h-8" /></div>}
// //             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Video className="w-3 h-3 inline mr-1" /> Video Upload</div>
// //           </div>
// //         );
// //       case 'instagram_reel':
// //       case 'instagram_feed':
// //         if (content.content_data.embed_code) {
// //           return (
// //             <div className="flex justify-center w-full bg-white dark:bg-gray-900 rounded-lg overflow-hidden p-2">
// //               <div className="instagram-embed-wrapper w-full flex justify-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
// //             </div>
// //           );
// //         }
// //         return (
// //           <div className="relative bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || (content.content_type === 'instagram_reel' ? '9/16' : '1/1'), minHeight: '300px' }} onClick={() => handleContentClick(content)}>
// //             {content.content_data.thumbnail_url ? <img src={content.content_data.thumbnail_url} alt={content.title} className="w-full h-full object-cover" /> : <div className="flex items-center justify-center h-full text-white"><Instagram className="w-8 h-8" /></div>}
// //             <div className="absolute bottom-2 left-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs px-2 py-1 rounded"><Instagram className="w-3 h-3 inline mr-1" /> {content.content_type === 'instagram_reel' ? 'Reel' : 'Post'}</div>
// //           </div>
// //         );
// //       case 'image':
// //         return (
// //           <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || 'auto' }} onClick={() => handleContentClick(content)}>
// //             <img src={content.content_data.url} alt={content.title} className="w-full h-full object-cover" onError={(e) => { e.target.src = '/api/placeholder/600/300'; }} />
// //             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Image className="w-3 h-3 inline mr-1" /> Gambar</div>
// //           </div>
// //         );
// //       case 'article':
// //         if (content.content_data.pdf_url) {
// //           return (
// //             <div className="relative aspect-video bg-gradient-to-br from-red-100 to-orange-100 dark:from-red-900 dark:to-orange-900 rounded-lg overflow-hidden cursor-pointer group" onClick={() => handleContentClick(content)}>
// //               <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
// //                 <FileText className="w-12 h-12 mb-3 text-red-600 dark:text-red-400" />
// //                 <p className="text-sm font-semibold text-center mb-2 text-gray-800 dark:text-gray-200">{content.title}</p>
// //                 <Badge className="bg-red-500 text-white">PDF Tutorial</Badge>
// //               </div>
// //               <div className="absolute inset-0 bg-red-500 opacity-0 group-hover:opacity-10 transition-opacity"></div>
// //             </div>
// //           );
// //         }
// //         return (
// //           <div className="aspect-video bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900 dark:to-purple-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
// //             <div className="text-center">
// //               <FileText className="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" />
// //               <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-3">{content.content_data.text?.substring(0, 100)}...</p>
// //             </div>
// //           </div>
// //         );
// //       case 'file':
// //         const isPdf = content.content_data?.url?.toLowerCase().endsWith('.pdf');
// //         const coverImage = content.content_data?.cover_image_url;

// //         // JIKA ADA COVER IMAGE
// //         if (coverImage) {
// //           return (
// //             <div
// //               className="relative aspect-video rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02] bg-cover bg-center"
// //               style={{ backgroundImage: `url(${coverImage})` }}
// //               onClick={() => handleContentClick(content)}
// //             >
// //               <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors"></div>

// //               <div className="relative z-10 flex flex-col items-center">
// //                 <BookOpen className="w-12 h-12 mb-2 opacity-90 drop-shadow-md" />
// //                 <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2 drop-shadow-md px-2">{content.title}</p>
// //                 <p className="text-[9px] opacity-90 text-center mt-1 bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded-full">Klik untuk membaca</p>
// //               </div>

// //               {isPdf && (
// //                 <div className="absolute top-2 right-2 bg-red-600 shadow-md text-white text-[9px] font-bold px-1.5 py-0.5 rounded z-10">PDF</div>
// //               )}
// //             </div>
// //           );
// //         }

// //         // DEFAULT FALLBACK (JIKA TIDAK ADA COVER IMAGE)
// //         if (isPdf) {
// //           return (
// //             <div className="relative aspect-video bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02]" onClick={() => handleContentClick(content)}>
// //               <BookOpen className="w-12 h-12 mb-2 opacity-90" />
// //               <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2">{content.title}</p>
// //               <p className="text-[9px] opacity-75 text-center mt-1 bg-white/20 px-2 py-0.5 rounded-full">Klik untuk membaca</p>
// //               <div className="absolute top-2 right-2 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">PDF</div>
// //             </div>
// //           );
// //         }
// //         return (
// //           <div className="aspect-video bg-gradient-to-br from-green-100 to-blue-100 dark:from-green-900 dark:to-blue-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
// //             <div className="text-center">
// //               <FileText className="w-8 h-8 mx-auto mb-2 text-green-600 dark:text-green-400" />
// //               <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">{content.content_data.file_name || 'File'}</p>
// //               <Button className="bg-green-600 text-white hover:bg-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300" size="sm"><ExternalLink className="w-4 h-4 mr-2" /> Download File</Button>
// //             </div>
// //           </div>
// //         );
// //       default:
// //         return <div className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center"><FileText className="w-8 h-8 text-gray-400" /></div>;
// //     }
// //   };

// //   // PENTING: Gunakan useMemo untuk array warna partikel agar tidak direferensikan ulang setiap render
// //   // Ini mencegah Particles component re-render yang menyebabkan "flicker/gerak"
// //   const particleColors = useMemo(() =>
// //     ['#1e1e1e', '#3b82f6', '#1d4ed8'],
// //     [] // Empty dependency array karena warna statis untuk light mode
// //   );

// //   const navItems = [
// //     {
// //       label: "Tentang",
// //       bgColor: "#0D0716",
// //       textColor: "#fff",
// //       links: [
// //         { label: "Perusahaan", ariaLabel: "Tentang Perusahaan", href: "https://mpstore.co.id/about" },
// //         { label: "Karir", ariaLabel: "Karir", href: "https://mpstore.co.id/career" }
// //       ]
// //     },
// //     {
// //       label: "Layanan",
// //       bgColor: "#170D27",
// //       textColor: "#fff",
// //       links: [
// //         { label: "QRIS", ariaLabel: "QRIS", href: "https://mpstore.co.id/apps" },
// //         { label: "Agen Pulsa & PPOB", ariaLabel: "Agen Pulsa & PPOB", href: "#" },
// //         { label: "Kulakan Indomarco", ariaLabel: "Kulakan Indomarco", href: "#" },
// //         { label: "Logistik Kasir", ariaLabel: "Logistik Kasir", href: "#" },
// //         { label: "Akses Permodalan", ariaLabel: "Akses Permodalan", href: "#" },
// //         { label: "Miniweb", ariaLabel: "Miniweb", href: "#" }
// //       ]
// //     },
// //     {
// //       label: "Bantuan",
// //       bgColor: "#271E37",
// //       textColor: "#fff",
// //       links: [
// //         { label: "WhatsApp CS", ariaLabel: "Hubungi CS", href: "https://api.whatsapp.com/send/?phone=6285812626667" },
// //         { label: "Email", ariaLabel: "Email Kami", href: "mailto:support@mpstore.co.id" },
// //         { label: "FAQ", ariaLabel: "Tanya Jawab", href: "#" }
// //       ]
// //     }
// //   ];

// //   return (
// //     // CLASS 'dark' DIHAPUS DARI SINI. Hanya pakai class biasa.
// //     <div className="min-h-screen transition-colors duration-300 relative text-gray-900">

// //       <Particles
// //         particleColors={particleColors}
// //         particleCount={200}
// //         particleSpread={10}
// //         speed={0.1}
// //         particleBaseSize={100}
// //         moveParticlesOnHover={true}
// //         alphaParticles={false}
// //         disableRotation={false}
// //         className="fixed inset-0 w-full h-full"
// //       />

// //       {/* PDF Viewer Modal */}
// //       {pdfViewerOpen && (
// //         <Dialog open={pdfViewerOpen} onOpenChange={setPdfViewerOpen}>
// //           <DialogContent className="max-w-5xl w-[95vw] h-[90vh] p-0 overflow-hidden bg-zinc-900 border-zinc-800">
// //             <div className="flex flex-col h-full">
// //               <div className="flex items-center justify-between p-4 bg-zinc-900 text-white border-b border-zinc-800">
// //                 <h3 className="font-medium truncate flex items-center gap-2">
// //                   <BookOpen className="w-5 h-5 text-blue-400" />
// //                   {currentPdfTitle || "Document Viewer"}
// //                 </h3>
// //                 <div className="flex items-center gap-2">
// //                   <button
// //                     onClick={handleDownloadPdf}
// //                     className="text-xs bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
// //                   >
// //                     <ExternalLink className="w-3 h-3 mr-1" /> Download
// //                   </button>
// //                   <a
// //                     href={currentPdfUrl}
// //                     target="_blank"
// //                     rel="noreferrer"
// //                     className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
// //                   >
// //                     <ExternalLink className="w-3 h-3 mr-1" /> Buka Full
// //                   </a>
// //                   <button onClick={() => setPdfViewerOpen(false)} className="text-zinc-400 hover:text-white">
// //                     <X className="w-6 h-6" />
// //                   </button>
// //                 </div>
// //               </div>
// //               <div className="flex-1 bg-zinc-800 relative">
// //                 {currentPdfUrl ? (
// //                   <iframe
// //                     src={`${currentPdfUrl}#toolbar=0&view=FitH`}
// //                     title="PDF Viewer"
// //                     className="w-full h-full absolute inset-0 border-0"
// //                   />
// //                 ) : (
// //                   <div className="flex items-center justify-center h-full text-zinc-500">
// //                     Memuat Dokumen...
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           </DialogContent>
// //         </Dialog>
// //       )}

// //       <div className="relative z-10 flex flex-col min-h-screen">
// //         <CardNav
// //           logo="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
// //           logoAlt="MPStore Logo"
// //           items={navItems}
// //           // HARDCODE WARNA LIGHT MODE
// //           baseColor="rgba(255, 255, 255, 0.8)"
// //           menuColor="#000"
// //           buttonBgColor="#2563eb"
// //           buttonTextColor="#fff"
// //           ease="power3.out"
// //         />

// //         <main className="container mx-auto px-4 py-8 pt-32 flex-grow">

// //           <div className="mb-8 w-full flex flex-col items-center text-center gap-6">
// //             <div className="w-full overflow-hidden mt-8">
// //               <SplitText
// //                 text="Selamat Datang di MPStore Training Center"
// //                 className="text-4xl md:text-5xl font-bold text-center text-blue-600 pb-2 drop-shadow-md"
// //                 delay={50}
// //                 duration={1}
// //                 ease="back.out(1.7)"
// //                 threshold={0.1}
// //                 rootMargin="-50px"
// //                 onLetterAnimationComplete={handleAnimationComplete}
// //               />
// //             </div>

// //             <div className="min-h-[40px]">
// //               <TextType
// //                 text={[
// //                   "Belajar fitur-fitur MPStore dengan mudah",
// //                   "Tutorial lengkap untuk kembangkan bisnismu",
// //                   "Kelola usaha jadi lebih efisien!"
// //                 ]}
// //                 className="text-lg md:text-xl text-gray-600 font-medium"
// //                 typingSpeed={50}
// //                 pauseDuration={2000}
// //                 deletingSpeed={30}
// //                 cursorCharacter="|"
// //                 cursorClassName="text-blue-500 font-bold"
// //               />
// //             </div>

// //             <div className="w-full max-w-2xl mx-auto mt-4">
// //               <div className="relative group">
// //                 <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 blur"></div>
// //                 <div className="relative flex bg-white rounded-full p-1">
// //                   <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// //                   <Input
// //                     type="text"
// //                     placeholder="Cari tutorial, tips, atau tanyakan apapun..."
// //                     value={query}
// //                     onChange={(e) => setQuery(e.target.value)}
// //                     onKeyPress={handleKeyPress}
// //                     className="pl-12 pr-4 py-6 w-full bg-transparent border-0 focus:ring-0 focus-visible:ring-0 rounded-full text-lg"
// //                   />
// //                   {query && (
// //                     <Button
// //                       onClick={() => handleSearch()}
// //                       disabled={loading}
// //                       className="rounded-full px-8 bg-blue-600 hover:bg-blue-700 text-white"
// //                     >
// //                       {loading ? '...' : 'Cari'}
// //                     </Button>
// //                   )}
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           {searchResult && (
// //             <section className="mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
// //               <div className="max-w-4xl mx-auto space-y-8">
// //                 <div className="text-center px-4">
// //                   <h2 className="text-xl md:text-3xl font-bold mb-4 break-words leading-tight">
// //                     Hasil pencarian: "{searchResult.query}"
// //                   </h2>
// //                   <Button variant="outline" onClick={() => setSearchResult(null)} className="rounded-full text-sm md:text-base h-8 md:h-10">
// //                     ← Kembali ke Beranda
// //                   </Button>
// //                 </div>

// //                 <Card className="bg-white/90 backdrop-blur-sm border-l-4 border-blue-500 shadow-lg">
// //                   <CardHeader>
// //                     <CardTitle className="flex items-center gap-2">
// //                       <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
// //                         <span className="text-white text-sm font-bold">AI</span>
// //                       </div>
// //                       Jawaban AI
// //                     </CardTitle>
// //                   </CardHeader>
// //                   <CardContent>
// //                     {searchResult.ai_loading ? (
// //                       <div className="flex items-center gap-2">
// //                         <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
// //                         <span className="text-gray-600">Sedang menganalisis...</span>
// //                       </div>
// //                     ) : searchResult.ai_response ? (
// //                       <div className="prose prose-sm max-w-none">
// //                         <p className="whitespace-pre-wrap">{searchResult.ai_response}</p>
// //                       </div>
// //                     ) : (
// //                       <p className="text-gray-500">Tidak ada respons AI yang tersedia.</p>
// //                     )}
// //                   </CardContent>
// //                 </Card>

// //                 {searchResult.local_results && searchResult.local_results.length > 0 && (
// //                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
// //                     {searchResult.local_results.map((content) => (
// //                       <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/80 backdrop-blur-sm overflow-hidden cursor-pointer" onClick={() => handleContentClick(content)}>
// //                         <div className="relative">{renderContent(content)}</div>
// //                         <CardContent className="p-4">
// //                           <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
// //                             <span>{formatTimeAgo(content.created_at)}</span>
// //                           </div>
// //                           <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
// //                             {content.title}
// //                           </h4>
// //                         </CardContent>
// //                       </Card>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>
// //             </section>
// //           )}

// //           {!searchResult && (
// //             <>
// //               <section className="mb-8 mt-12">
// //                 <h3 className="text-2xl font-bold mb-6 text-center">Kategori Populer</h3>
// //                 <div className="flex flex-wrap justify-center gap-3">
// //                   {allTags.map((tag) => (
// //                     <Button key={tag} variant="outline" onClick={() => handleTagClick(tag)} className="rounded-full bg-white/50 hover:bg-blue-50 border-gray-300 backdrop-blur-sm">
// //                       {tag}
// //                     </Button>
// //                   ))}
// //                 </div>
// //               </section>

// //               <div className="mb-1">
// //                 <CurvedLoop
// //                   marqueeText="Kasir | Qris | Akses Permodalan | Mini Website | Agen Pulsa & PPOB | Kulakan Indomarco | Logistik"
// //                   speed={2}
// //                   curveAmount={0}
// //                   className="text-grey-600"
// //                 />
// //               </div>

// //               <section className="mb-8">
// //                 <div className="flex space-x-1 mb-6 bg-gray-100/80 p-1 rounded-full max-w-md backdrop-blur-sm mx-auto">
// //                   {[
// //                     { id: 'video', label: 'Video' },
// //                     { id: 'buku tutorial', label: 'Buku Tutorial' },
// //                     { id: 'konten', label: 'Konten' }
// //                   ].map((tab) => (
// //                     <Button
// //                       key={tab.id}
// //                       variant={activeContentTab === tab.id ? "default" : "ghost"}
// //                       size="sm"
// //                       onClick={() => setActiveContentTab(tab.id)}
// //                       className={`flex-1 rounded-full transition-all ${activeContentTab === tab.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
// //                     >
// //                       {tab.label}
// //                     </Button>
// //                   ))}
// //                 </div>
// //               </section>

// //               <div className="grid lg:grid-cols-4 gap-8">
// //                 <div className="lg:col-span-3">
// //                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-y-auto max-h-[calc(100vh-50px)] pr-4 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200">
// //                     {filteredContent.length === 0 ? (
// //                       <div className="col-span-full text-center py-12 text-gray-500">
// //                         <p>Belum ada konten untuk kategori ini.</p>
// //                       </div>
// //                     ) : (
// //                       filteredContent.map((content) => (
// //                         <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/90 backdrop-blur-sm cursor-pointer" onClick={() => handleContentClick(content)}>
// //                           <div className="relative overflow-hidden">{renderContent(content)}</div>
// //                           <CardContent className="p-4">
// //                             <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
// //                               <span>{formatTimeAgo(content.created_at)}</span>
// //                               <div className="flex items-center space-x-3"><span className="flex items-center"><Eye className="w-3 h-3 mr-1" />{Math.floor(Math.random() * 1000)}</span></div>
// //                             </div>
// //                             <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</h4>
// //                             <div className="flex flex-wrap gap-1">{content.tags.slice(0, 2).map((tag) => (<Badge key={tag} variant="secondary" className="text-xs bg-gray-100/80">{tag}</Badge>))}</div>
// //                           </CardContent>
// //                         </Card>
// //                       ))
// //                     )}
// //                   </div>
// //                 </div>

// //                 <div className="lg:col-span-1">
// //                   <div className="sticky top-24 space-y-6">
// //                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
// //                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><TrendingUp className="w-5 h-5 mr-2 text-orange-500" /> Trending</CardTitle></CardHeader>
// //                       <CardContent className="space-y-4">
// //                         {trendingContent.map((content, index) => (
// //                           <div key={content.id} className="flex items-start space-x-3 group cursor-pointer" onClick={() => handleContentClick(content)}>
// //                             <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${index === 0 ? 'bg-yellow-500 text-white' : index === 1 ? 'bg-gray-400 text-white' : index === 2 ? 'bg-yellow-600 text-white' : 'bg-gray-200 text-gray-600'}`}>{index + 1}</div>
// //                             <div className="flex-1 min-w-0"><p className="text-sm font-medium line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</p><p className="text-xs text-gray-500 mt-1">{Math.floor(Math.random() * 500) + 100} views</p></div>
// //                           </div>
// //                         ))}
// //                       </CardContent>
// //                     </Card>
// //                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
// //                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><Star className="w-5 h-5 mr-2 text-blue-500" /> MPStore Resources</CardTitle></CardHeader>
// //                       <CardContent className="space-y-3">
// //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://apps.apple.com/id/app/mpstore-superapp-umkm/id1514516462?mt=8', '_blank')}><Smartphone className="w-4 h-4 mr-2" /> Download App</Button>
// //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.instagram.com/mpstore_superappumkm/', '_blank')}><Instagram className="w-4 h-4 mr-2" /> Instagram</Button>
// //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.facebook.com/people/MPStore/100087175355298/', '_blank')}><Facebook className="w-4 h-4 mr-2" /> Facebook</Button>
// //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667&text&type=phone_number&app_absent=0', '_blank')}><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp CS</Button>
// //                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}><Newspaper className="w-4 h-4 mr-2" /> News & Updates</Button>
// //                       </CardContent>
// //                     </Card>
// //                   </div>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </main>

// //         <Footer />

// //         <div className="fixed bottom-6 right-6 z-50">
// //           <Button
// //             onClick={() => window.location.href = '/admin'}
// //             variant="outline"
// //             className="shadow-lg rounded-full h-12 w-12 p-0 bg-white"
// //           >
// //             <Settings className="w-6 h-6" />
// //           </Button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ModernHomepage;

// import React, { useState, useEffect, useMemo } from "react";
// import { useLanguage } from "../lib/LanguageContext"; // Menggunakan Custom Context
// import { Button } from "./ui/button.jsx";
// import { Input } from "./ui/input.jsx";
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card.jsx";
// import { Badge } from "./ui/badge.jsx";
// import { Search, Video, FileText, Image, Instagram, Facebook, MessageCircle, Newspaper, Smartphone, ExternalLink, Play, Eye, TrendingUp, Star, Settings, X, BookOpen } from "lucide-react";
// import axios from "axios";
// import SplitText from "./SplitText.js";
// import Particles from "./Particles.js";
// import TextType from "./TextType.js";
// import CardNav from "./CardNav.js";
// import Footer from "./Footer.js";
// import CurvedLoop from "./CurvedLoop.js";
// import { Dialog, DialogContent } from "./ui/dialog.jsx";
// import LanguageToggle from "./LanguageToggle.js";

// const ModernHomepage = () => {
//   const { t } = useLanguage(); // Menggunakan custom hook t
//   const [query, setQuery] = useState("");
//   const [searchResult, setSearchResult] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [aiLoading, setAiLoading] = useState(false);
//   const [allTags, setAllTags] = useState([]);
//   const [allFetchedContent, setAllFetchedContent] = useState([]);

//   const [activeContentTab, setActiveContentTab] = useState('video');
//   const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
//   const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
//   const [currentPdfTitle, setCurrentPdfTitle] = useState("");

//   const handleAnimationComplete = () => {
//     console.log('Text animation completed!');
//   };

//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
//   const API = `${BACKEND_URL}/api`;

//   const filteredContent = useMemo(() => {
//     if (!allFetchedContent || allFetchedContent.length === 0) return [];

//     switch (activeContentTab) {
//       case 'video':
//         return allFetchedContent.filter(c => c.content_type === 'video_youtube');

//       case 'buku tutorial':
//         return allFetchedContent.filter(c => c.content_type === 'file');

//       case 'konten':
//         return allFetchedContent.filter(c =>
//           ['instagram_reel', 'instagram_feed', 'video_tiktok'].includes(c.content_type)
//         );

//       default:
//         return allFetchedContent.filter(c => c.content_type === 'video_youtube');
//     }
//   }, [activeContentTab, allFetchedContent]);

//   const trendingContent = useMemo(() => {
//     return allFetchedContent.slice(0, 5);
//   }, [allFetchedContent]);

//   useEffect(() => {
//     fetchInitialData();

//     // --- LOGIKA LIGHT MODE PERMANEN ---
//     document.documentElement.classList.remove('dark');
//     localStorage.removeItem('theme');

//     const loadScript = (id, src) => {
//       if (!document.getElementById(id)) {
//         const script = document.createElement('script');
//         script.id = id;
//         script.src = src;
//         script.async = true;
//         document.body.appendChild(script);
//       }
//     };

//     loadScript('tiktok-embed-script', 'https://www.tiktok.com/embed.js');
//     loadScript('instagram-embed-script', '//www.instagram.com/embed.js');

//   }, []);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (window.instgrm) {
//         window.instgrm.Embeds.process();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [filteredContent, activeContentTab]);

//   const fetchInitialData = async () => {
//     try {
//       const tagsResponse = await axios.get(`${API}/search/tags`);
//       console.log(tagsResponse.data)
//       setAllTags(tagsResponse.data.slice(0, 12));

//       const contentTypes = ['video_youtube', 'file', 'instagram_reel', 'instagram_feed', 'video_tiktok'];

//       const responses = await Promise.all(
//         contentTypes.map(type => axios.get(`${API}/content/by-type/${type}`))
//       );

//       const allContent = [];
//       responses.forEach(response => {
//         if (response.data && Array.isArray(response.data.content)) {
//           allContent.push(...response.data.content);
//         }
//       });

//       const uniqueContent = Array.from(new Map(allContent.map(item => [item.id, item])).values());
//       const shuffled = uniqueContent.sort(() => 0.5 - Math.random());
//       setAllFetchedContent(shuffled);

//     } catch (error) {
//       console.error("Error fetching initial data:", error);
//     }
//   };

//   const getContentImage = (content) => {
//     if (content.content_type === 'image' && content.content_data.url) {
//       const separator = content.content_data.url.includes('?') ? '&' : '?';
//       return `${content.content_data.url}${separator}v=${Date.now()}`;
//     }
//     if (content.content_type === 'video_youtube') {
//       const embedUrl = content.content_data.embed_url;
//       const videoId = embedUrl?.match(/embed\/([^?]*)/)?.[1];
//       return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '/api/placeholder/600/300';
//     }
//     if (content.content_data.thumbnail_url) {
//       const separator = content.content_data.thumbnail_url.includes('?') ? '&' : '?';
//       return `${content.content_data.thumbnail_url}${separator}v=${Date.now()}`;
//     }
//     return '/api/placeholder/600/300';
//   };

//   const getContentLink = (content) => {
//     if (content.content_type === 'video_youtube') {
//       return content.content_data.embed_url?.replace('embed/', 'watch?v=');
//     }
//     if (content.content_type === 'video_upload' || content.content_type === 'video_tiktok') {
//       return content.content_data.original_url || content.content_data.url;
//     }
//     if (content.content_type.includes('instagram')) {
//       return content.content_data.original_url;
//     }
//     if (content.content_type === 'article') {
//       if (content.content_data.pdf_url) {
//         return content.content_data.pdf_url;
//       }
//       return `/article/${content.id}`;
//     }
//     if (content.content_type === 'file') {
//       return content.content_data.url;
//     }
//     if (content.content_type === 'image') {
//       return content.content_data.url;
//     }
//     return content.content_data.url || '#';
//   };

//   const handleSearch = async (searchQuery = query) => {
//     if (!searchQuery.trim()) return;
//     setLoading(true);
//     try {
//       const localResponse = await axios.post(`${API}/search/content`, { query: searchQuery });
//       const localResults = [...(localResponse.data.related_videos || []), ...(localResponse.data.related_content || [])];
//       setSearchResult({
//         query: searchQuery,
//         local_results: localResults,
//         ai_response: null,
//         ai_loading: true
//       });
//       setAiLoading(true);
//       const aiResponse = await axios.post(`${API}/search/ai`, { query: searchQuery });
//       setSearchResult(prev => ({ ...prev, ai_response: aiResponse.data.ai_response, ai_loading: false }));
//     } catch (error) {
//       console.error("Search error:", error);
//     } finally {
//       setLoading(false);
//       setAiLoading(false);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSearch();
//     }
//   };

//   const handleTagClick = (tag) => {
//     setQuery(tag);
//     handleSearch(tag);
//   };

//   const formatTimeAgo = (dateString) => {
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
//     if (diffInHours < 1) return 'Baru saja';
//     if (diffInHours < 24) return `${diffInHours} jam yang lalu`;
//     const diffInDays = Math.floor(diffInHours / 24);
//     if (diffInDays < 7) return `${diffInDays} hari yang lalu`;
//     return date.toLocaleDateString('id-ID');
//   };

//   const handleDownloadPdf = async () => {
//     try {
//       const downloadUrl = `${API}/download-pdf?url=${encodeURIComponent(currentPdfUrl)}&filename=${encodeURIComponent(currentPdfTitle + '.pdf')}`;

//       const link = document.createElement('a');
//       link.href = downloadUrl;
//       link.download = currentPdfTitle + '.pdf';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error('Download error:', error);
//       const link = document.createElement('a');
//       link.href = currentPdfUrl;
//       link.download = currentPdfTitle + '.pdf';
//       link.target = '_blank';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   const handleContentClick = (content) => {
//     if (content.content_data.embed_code || content.content_data.embed_html) return;

//     if (content.content_type === 'file' && content.content_data.url && content.content_data.url.toLowerCase().endsWith('.pdf')) {
//       setCurrentPdfUrl(content.content_data.url);
//       setCurrentPdfTitle(content.title);
//       setPdfViewerOpen(true);
//       return;
//     }

//     if (content.content_type === 'article' && content.content_data.pdf_url) {
//       setCurrentPdfUrl(content.content_data.pdf_url);
//       setCurrentPdfTitle(content.title);
//       setPdfViewerOpen(true);
//       return;
//     }

//     const contentLink = getContentLink(content);
//     if (contentLink !== '#') {
//       window.open(contentLink, '_blank');
//     }
//   };

//   const closePdfViewer = () => {
//     setPdfViewerOpen(false);
//     setCurrentPdfUrl(null);
//     setCurrentPdfTitle("");
//   };

//   const renderContent = (content) => {
//     switch (content.content_type) {
//       case 'video_youtube':
//         return (
//           <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden group">
//             {content.content_data.embed_url ? (
//               <iframe
//                 src={content.content_data.embed_url}
//                 title={content.title}
//                 className="w-full h-full rounded-lg"
//                 allowFullScreen
//                 frameBorder="0"
//               />
//             ) : (
//               <img src={getContentImage(content)} alt={content.title} className="w-full h-full object-cover" />
//             )}
//             <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
//               <Video className="w-3 h-3 inline mr-1" /> Video
//             </div>
//           </div>
//         );
//       case 'video_tiktok':
//         return (
//           <div className="flex justify-center items-center bg-transparent rounded-lg">
//             {content.content_data.embed_html ? (
//               <div className="w-full [&>blockquote]:m-0 [&>blockquote]:mx-auto" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
//             ) : (
//               <a href={content.content_data.original_url} target="_blank" rel="noopener noreferrer" className="text-white bg-black rounded p-4 block">{t('view_on_tiktok')}</a>
//             )}
//           </div>
//         );
//       case 'video_upload':
//         return (
//           <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden group cursor-pointer" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || '16/9' }} onClick={() => handleContentClick(content)}>
//             {content.content_data.url ? (
//               <video controls playsInline className="w-full h-full rounded-lg object-cover"><source src={content.content_data.url} type="video/mp4" /></video>
//             ) : <div className="flex items-center justify-center h-full text-gray-400"><Video className="w-8 h-8" /></div>}
//             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Video className="w-3 h-3 inline mr-1" /> Video Upload</div>
//           </div>
//         );
//       case 'instagram_reel':
//       case 'instagram_feed':
//         if (content.content_data.embed_code) {
//           return (
//             <div className="flex justify-center w-full bg-white dark:bg-gray-900 rounded-lg overflow-hidden p-2">
//               <div className="instagram-embed-wrapper w-full flex justify-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
//             </div>
//           );
//         }
//         return (
//           <div className="relative bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || (content.content_type === 'instagram_reel' ? '9/16' : '1/1'), minHeight: '300px' }} onClick={() => handleContentClick(content)}>
//             {content.content_data.thumbnail_url ? <img src={content.content_data.thumbnail_url} alt={content.title} className="w-full h-full object-cover" /> : <div className="flex items-center justify-center h-full text-white"><Instagram className="w-8 h-8" /></div>}
//             <div className="absolute bottom-2 left-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs px-2 py-1 rounded"><Instagram className="w-3 h-3 inline mr-1" /> {content.content_type === 'instagram_reel' ? 'Reel' : 'Post'}</div>
//           </div>
//         );
//       case 'image':
//         return (
//           <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || 'auto' }} onClick={() => handleContentClick(content)}>
//             <img src={content.content_data.url} alt={content.title} className="w-full h-full object-cover" onError={(e) => { e.target.src = '/api/placeholder/600/300'; }} />
//             <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Image className="w-3 h-3 inline mr-1" /> Gambar</div>
//           </div>
//         );
//       case 'article':
//         if (content.content_data.pdf_url) {
//           return (
//             <div className="relative aspect-video bg-gradient-to-br from-red-100 to-orange-100 dark:from-red-900 dark:to-orange-900 rounded-lg overflow-hidden cursor-pointer group" onClick={() => handleContentClick(content)}>
//               <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
//                 <FileText className="w-12 h-12 mb-3 text-red-600 dark:text-red-400" />
//                 <p className="text-sm font-semibold text-center mb-2 text-gray-800 dark:text-gray-200">{content.title}</p>
//                 <Badge className="bg-red-500 text-white">PDF Tutorial</Badge>
//               </div>
//               <div className="absolute inset-0 bg-red-500 opacity-0 group-hover:opacity-10 transition-opacity"></div>
//             </div>
//           );
//         }
//         return (
//           <div className="aspect-video bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900 dark:to-purple-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
//             <div className="text-center">
//               <FileText className="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" />
//               <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-3">{content.content_data.text?.substring(0, 100)}...</p>
//             </div>
//           </div>
//         );
//       case 'file':
//         const isPdf = content.content_data?.url?.toLowerCase().endsWith('.pdf');
//         const coverImage = content.content_data?.cover_image_url;

//         // JIKA ADA COVER IMAGE
//         if (coverImage) {
//           return (
//             <div
//               className="relative aspect-video rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02] bg-cover bg-center"
//               style={{ backgroundImage: `url(${coverImage})` }}
//               onClick={() => handleContentClick(content)}
//             >
//               <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors"></div>

//               <div className="relative z-10 flex flex-col items-center">
//                 <BookOpen className="w-12 h-12 mb-2 opacity-90 drop-shadow-md" />
//                 <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2 drop-shadow-md px-2">{content.title}</p>
//                 <p className="text-[9px] opacity-90 text-center mt-1 bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded-full">{t('read_click')}</p>
//               </div>

//               {isPdf && (
//                 <div className="absolute top-2 right-2 bg-red-600 shadow-md text-white text-[9px] font-bold px-1.5 py-0.5 rounded z-10">PDF</div>
//               )}
//             </div>
//           );
//         }

//         // DEFAULT FALLBACK (JIKA TIDAK ADA COVER IMAGE)
//         if (isPdf) {
//           return (
//             <div className="relative aspect-video bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02]" onClick={() => handleContentClick(content)}>
//               <BookOpen className="w-12 h-12 mb-2 opacity-90" />
//               <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2">{content.title}</p>
//               <p className="text-[9px] opacity-75 text-center mt-1 bg-white/20 px-2 py-0.5 rounded-full">{t('read_click')}</p>
//               <div className="absolute top-2 right-2 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">PDF</div>
//             </div>
//           );
//         }
//         return (
//           <div className="aspect-video bg-gradient-to-br from-green-100 to-blue-100 dark:from-green-900 dark:to-blue-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
//             <div className="text-center">
//               <FileText className="w-8 h-8 mx-auto mb-2 text-green-600 dark:text-green-400" />
//               <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">{content.content_data.file_name || 'File'}</p>
//               <Button className="bg-green-600 text-white hover:bg-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300" size="sm"><ExternalLink className="w-4 h-4 mr-2" /> {t('download')} File</Button>
//             </div>
//           </div>
//         );
//       default:
//         return <div className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center"><FileText className="w-8 h-8 text-gray-400" /></div>;
//     }
//   };

//   const particleColors = useMemo(() =>
//     ['#1e1e1e', '#3b82f6', '#1d4ed8'],
//     []
//   );

//   const navItems = [
//     {
//       label: "Tentang",
//       bgColor: "#0D0716",
//       textColor: "#fff",
//       links: [
//         { label: "Perusahaan", ariaLabel: "Tentang Perusahaan", href: "https://mpstore.co.id/about" },
//         { label: "Karir", ariaLabel: "Karir", href: "https://mpstore.co.id/career" }
//       ]
//     },
//     {
//       label: "Layanan",
//       bgColor: "#170D27",
//       textColor: "#fff",
//       links: [
//         { label: "QRIS", ariaLabel: "QRIS", href: "https://mpstore.co.id/apps" },
//         { label: "Agen Pulsa & PPOB", ariaLabel: "Agen Pulsa & PPOB", href: "#" },
//         { label: "Kulakan Indomarco", ariaLabel: "Kulakan Indomarco", href: "#" },
//         { label: "Logistik Kasir", ariaLabel: "Logistik Kasir", href: "#" },
//         { label: "Akses Permodalan", ariaLabel: "Akses Permodalan", href: "#" },
//         { label: "Miniweb", ariaLabel: "Miniweb", href: "#" }
//       ]
//     },
//     {
//       label: "Bantuan",
//       bgColor: "#271E37",
//       textColor: "#fff",
//       links: [
//         { label: "WhatsApp CS", ariaLabel: "Hubungi CS", href: "https://api.whatsapp.com/send/?phone=6285812626667" },
//         { label: "Email", ariaLabel: "Email Kami", href: "mailto:support@mpstore.co.id" },
//         { label: "FAQ", ariaLabel: "Tanya Jawab", href: "#" }
//       ]
//     }
//   ];

//   return (
//     // CLASS 'dark' DIHAPUS DARI SINI. Hanya pakai class biasa.
//     <div className="min-h-screen transition-colors duration-300 relative text-gray-900">

//       <Particles
//         particleColors={particleColors}
//         particleCount={200}
//         particleSpread={10}
//         speed={0.1}
//         particleBaseSize={100}
//         moveParticlesOnHover={true}
//         alphaParticles={false}
//         disableRotation={false}
//         className="fixed inset-0 w-full h-full"
//       />

//       {/* PDF Viewer Modal */}
//       {pdfViewerOpen && (
//         <Dialog open={pdfViewerOpen} onOpenChange={setPdfViewerOpen}>
//           <DialogContent className="max-w-5xl w-[95vw] h-[90vh] p-0 overflow-hidden bg-zinc-900 border-zinc-800">
//             <div className="flex flex-col h-full">
//               <div className="flex items-center justify-between p-4 bg-zinc-900 text-white border-b border-zinc-800">
//                 <h3 className="font-medium truncate flex items-center gap-2">
//                   <BookOpen className="w-5 h-5 text-blue-400" />
//                   {currentPdfTitle || "Document Viewer"}
//                 </h3>
//                 <div className="flex items-center gap-2">
//                   <button
//                     onClick={handleDownloadPdf}
//                     className="text-xs bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
//                   >
//                     <ExternalLink className="w-3 h-3 mr-1" /> {t('download')}
//                   </button>
//                   <a
//                     href={currentPdfUrl}
//                     target="_blank"
//                     rel="noreferrer"
//                     className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
//                   >
//                     <ExternalLink className="w-3 h-3 mr-1" /> {t('view_full')}
//                   </a>
//                   <button onClick={() => setPdfViewerOpen(false)} className="text-zinc-400 hover:text-white">
//                     <X className="w-6 h-6" />
//                   </button>
//                 </div>
//               </div>
//               <div className="flex-1 bg-zinc-800 relative">
//                 {currentPdfUrl ? (
//                   <iframe
//                     src={`${currentPdfUrl}#toolbar=0&view=FitH`}
//                     title="PDF Viewer"
//                     className="w-full h-full absolute inset-0 border-0"
//                   />
//                 ) : (
//                   <div className="flex items-center justify-center h-full text-zinc-500">
//                     Memuat Dokumen...
//                   </div>
//                 )}
//               </div>
//             </div>
//           </DialogContent>
//         </Dialog>
//       )}

//       <div className="relative z-10 flex flex-col min-h-screen">
//         <CardNav
//           logo="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
//           logoAlt="MPStore Logo"
//           items={navItems}
//           baseColor="rgba(255, 255, 255, 0.8)"
//           menuColor="#000"
//           buttonBgColor="#2563eb"
//           buttonTextColor="#fff"
//           ease="power3.out"
//         />

//         {/* Language Toggle - Positioning */}
//         <div className="fixed top-6 right-6 z-50 flex items-center gap-2">
//           <LanguageToggle />
//         </div>

//         <main className="container mx-auto px-4 py-8 pt-32 flex-grow">

//           <div className="mb-8 w-full flex flex-col items-center text-center gap-6">
//             <div className="w-full overflow-hidden mt-8">
//               <SplitText
//                 text={t('welcome_title')}
//                 className="text-4xl md:text-5xl font-bold text-center text-blue-600 pb-2 drop-shadow-md"
//                 delay={50}
//                 duration={1}
//                 ease="back.out(1.7)"
//                 threshold={0.1}
//                 rootMargin="-50px"
//                 onLetterAnimationComplete={handleAnimationComplete}
//               />
//             </div>

//             <div className="min-h-[40px]">
//               <TextType
//                 text={[
//                   t('typing_1'),
//                   t('typing_2'),
//                   t('typing_3')
//                 ]}
//                 className="text-lg md:text-xl text-gray-600 font-medium"
//                 typingSpeed={50}
//                 pauseDuration={2000}
//                 deletingSpeed={30}
//                 cursorCharacter="|"
//                 cursorClassName="text-blue-500 font-bold"
//               />
//             </div>

//             <div className="w-full max-w-2xl mx-auto mt-4">
//               <div className="relative group">
//                 <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 blur"></div>
//                 <div className="relative flex bg-white rounded-full p-1">
//                   <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
//                   <Input
//                     type="text"
//                     placeholder={t('search_placeholder')}
//                     value={query}
//                     onChange={(e) => setQuery(e.target.value)}
//                     onKeyPress={handleKeyPress}
//                     className="pl-12 pr-4 py-6 w-full bg-transparent border-0 focus:ring-0 focus-visible:ring-0 rounded-full text-lg"
//                   />
//                   {query && (
//                     <Button
//                       onClick={() => handleSearch()}
//                       disabled={loading}
//                       className="rounded-full px-8 bg-blue-600 hover:bg-blue-700 text-white"
//                     >
//                       {loading ? t('searching') : t('search_button')}
//                     </Button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {searchResult && (
//             <section className="mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
//               <div className="max-w-4xl mx-auto space-y-8">
//                 <div className="text-center">
//                   <h2 className="text-3xl font-bold mb-4">
//                     {t('search_result')}: "{searchResult.query}"
//                   </h2>
//                   <Button variant="outline" onClick={() => setSearchResult(null)} className="rounded-full">
//                     ← {t('back_home')}
//                   </Button>
//                 </div>

//                 <Card className="bg-white/90 backdrop-blur-sm border-l-4 border-blue-500 shadow-lg">
//                   <CardHeader>
//                     <CardTitle className="flex items-center gap-2">
//                       <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
//                         <span className="text-white text-sm font-bold">AI</span>
//                       </div>
//                       {t('ai_answer')}
//                     </CardTitle>
//                   </CardHeader>
//                   <CardContent>
//                     {searchResult.ai_loading ? (
//                       <div className="flex items-center gap-2">
//                         <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
//                         <span className="text-gray-600">{t('analyzing')}</span>
//                       </div>
//                     ) : searchResult.ai_response ? (
//                       <div className="prose prose-sm max-w-none">
//                         <p className="whitespace-pre-wrap">{searchResult.ai_response}</p>
//                       </div>
//                     ) : (
//                       <p className="text-gray-500">{t('no_ai_response')}</p>
//                     )}
//                   </CardContent>
//                 </Card>

//                 {searchResult.local_results && searchResult.local_results.length > 0 && (
//                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {searchResult.local_results.map((content) => (
//                       <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/80 backdrop-blur-sm overflow-hidden cursor-pointer" onClick={() => handleContentClick(content)}>
//                         <div className="relative">{renderContent(content)}</div>
//                         <CardContent className="p-4">
//                           <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
//                             <span>{formatTimeAgo(content.created_at)}</span>
//                           </div>
//                           <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
//                             {content.title}
//                           </h4>
//                         </CardContent>
//                       </Card>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </section>
//           )}

//           {!searchResult && (
//             <>
//               <section className="mb-8 mt-12">
//                 <h3 className="text-2xl font-bold mb-6 text-center">{t('popular_categories')}</h3>
//                 <div className="flex flex-wrap justify-center gap-3">
//                   {allTags.map((tag) => (
//                     <Button key={tag} variant="outline" onClick={() => handleTagClick(tag)} className="rounded-full bg-white/50 hover:bg-blue-50 border-gray-300 backdrop-blur-sm">
//                       {tag}
//                     </Button>
//                   ))}
//                 </div>
//               </section>

//               <div className="mb-1">
//                 <CurvedLoop
//                   marqueeText="Kasir | Qris | Akses Permodalan | Mini Website | Agen Pulsa & PPOB | Kulakan Indomarco | Logistik"
//                   speed={2}
//                   curveAmount={0}
//                   className="text-grey-600"
//                 />
//               </div>

//               <section className="mb-8">
//                 <div className="flex space-x-1 mb-6 bg-gray-100/80 p-1 rounded-full max-w-md backdrop-blur-sm mx-auto">
//                   {[
//                     { id: 'video', label: t('tab_video') },
//                     { id: 'buku tutorial', label: t('tab_book') },
//                     { id: 'konten', label: t('tab_content') }
//                   ].map((tab) => (
//                     <Button
//                       key={tab.id}
//                       variant={activeContentTab === tab.id ? "default" : "ghost"}
//                       size="sm"
//                       onClick={() => setActiveContentTab(tab.id)}
//                       className={`flex-1 rounded-full transition-all ${activeContentTab === tab.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
//                     >
//                       {tab.label}
//                     </Button>
//                   ))}
//                 </div>
//               </section>

//               <div className="grid lg:grid-cols-4 gap-8">
//                 <div className="lg:col-span-3">
//                   <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-y-auto max-h-[calc(100vh-50px)] pr-4 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200">
//                     {filteredContent.length === 0 ? (
//                       <div className="col-span-full text-center py-12 text-gray-500">
//                         <p>{t('no_content')}</p>
//                       </div>
//                     ) : (
//                       filteredContent.map((content) => (
//                         <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/90 backdrop-blur-sm cursor-pointer" onClick={() => handleContentClick(content)}>
//                           <div className="relative overflow-hidden">{renderContent(content)}</div>
//                           <CardContent className="p-4">
//                             <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
//                               <span>{formatTimeAgo(content.created_at)}</span>
//                               <div className="flex items-center space-x-3"><span className="flex items-center"><Eye className="w-3 h-3 mr-1" />{Math.floor(Math.random() * 1000)}</span></div>
//                             </div>
//                             <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</h4>
//                             <div className="flex flex-wrap gap-1">{content.tags.slice(0, 2).map((tag) => (<Badge key={tag} variant="secondary" className="text-xs bg-gray-100/80">{tag}</Badge>))}</div>
//                           </CardContent>
//                         </Card>
//                       ))
//                     )}
//                   </div>
//                 </div>

//                 <div className="lg:col-span-1">
//                   <div className="sticky top-24 space-y-6">
//                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
//                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><TrendingUp className="w-5 h-5 mr-2 text-orange-500" /> {t('trending')}</CardTitle></CardHeader>
//                       <CardContent className="space-y-4">
//                         {trendingContent.map((content, index) => (
//                           <div key={content.id} className="flex items-start space-x-3 group cursor-pointer" onClick={() => handleContentClick(content)}>
//                             <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${index === 0 ? 'bg-yellow-500 text-white' : index === 1 ? 'bg-gray-400 text-white' : index === 2 ? 'bg-yellow-600 text-white' : 'bg-gray-200 text-gray-600'}`}>{index + 1}</div>
//                             <div className="flex-1 min-w-0"><p className="text-sm font-medium line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</p><p className="text-xs text-gray-500 mt-1">{Math.floor(Math.random() * 500) + 100} views</p></div>
//                           </div>
//                         ))}
//                       </CardContent>
//                     </Card>
//                     <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
//                       <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><Star className="w-5 h-5 mr-2 text-blue-500" /> {t('resources')}</CardTitle></CardHeader>
//                       <CardContent className="space-y-3">
//                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://apps.apple.com/id/app/mpstore-superapp-umkm/id1514516462?mt=8', '_blank')}><Smartphone className="w-4 h-4 mr-2" /> {t('download_app')}</Button>
//                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.instagram.com/mpstore_superappumkm/', '_blank')}><Instagram className="w-4 h-4 mr-2" /> Instagram</Button>
//                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.facebook.com/people/MPStore/100087175355298/', '_blank')}><Facebook className="w-4 h-4 mr-2" /> Facebook</Button>
//                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667&text&type=phone_number&app_absent=0', '_blank')}><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp CS</Button>
//                         <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}><Newspaper className="w-4 h-4 mr-2" /> {t('news_updates')}</Button>
//                       </CardContent>
//                     </Card>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </main>

//         <Footer />

//         <div className="fixed bottom-6 right-6 z-50">
//           <Button
//             onClick={() => window.location.href = '/admin'}
//             variant="outline"
//             className="shadow-lg rounded-full h-12 w-12 p-0 bg-white"
//           >
//             <Settings className="w-6 h-6" />
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ModernHomepage;

import React, { useState, useEffect, useMemo } from "react";
import { useLanguage } from "../lib/LanguageContext"; // Menggunakan Custom Context
import { Button } from "./ui/button.jsx";
import { Input } from "./ui/input.jsx";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card.jsx";
import { Badge } from "./ui/badge.jsx";
import { Search, Video, FileText, Image, Instagram, Facebook, MessageCircle, Newspaper, Smartphone, ExternalLink, Play, Eye, TrendingUp, Star, Settings, X, BookOpen } from "lucide-react";
import axios from "axios";
import SplitText from "./SplitText.js";
import Particles from "./Particles.js";
import TextType from "./TextType.js";
import CardNav from "./CardNav.js";
import Footer from "./Footer.js";
import CurvedLoop from "./CurvedLoop.js";
import { Dialog, DialogContent } from "./ui/dialog.jsx";
import LanguageToggle from "./LanguageToggle.js";
import FeedbackWidget from "./FeedbackWidget.js"; // IMPORT KOMPONEN FEEDBACK

const ModernHomepage = () => {
  const { t } = useLanguage();
  const [query, setQuery] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [allTags, setAllTags] = useState([]);
  const [allFetchedContent, setAllFetchedContent] = useState([]);

  // STATE BARU UNTUK MENYIMPAN QUERY PENCARIAN TERAKHIR
  const [lastSearchedQuery, setLastSearchedQuery] = useState("");

  const [activeContentTab, setActiveContentTab] = useState('video');
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
  const [currentPdfTitle, setCurrentPdfTitle] = useState("");

  const handleAnimationComplete = () => {
    console.log('Text animation completed!');
  };

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;

  const filteredContent = useMemo(() => {
    if (!allFetchedContent || allFetchedContent.length === 0) return [];

    switch (activeContentTab) {
      case 'video':
        return allFetchedContent.filter(c => c.content_type === 'video_youtube');

      case 'buku tutorial':
        return allFetchedContent.filter(c => c.content_type === 'file');

      case 'konten':
        return allFetchedContent.filter(c =>
          ['instagram_reel', 'instagram_feed', 'video_tiktok'].includes(c.content_type)
        );

      default:
        return allFetchedContent.filter(c => c.content_type === 'video_youtube');
    }
  }, [activeContentTab, allFetchedContent]);

  const trendingContent = useMemo(() => {
    return allFetchedContent.slice(0, 5);
  }, [allFetchedContent]);

  useEffect(() => {
    fetchInitialData();

    // --- LOGIKA LIGHT MODE PERMANEN ---
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('theme');

    const loadScript = (id, src) => {
      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = true;
        document.body.appendChild(script);
      }
    };

    loadScript('tiktok-embed-script', 'https://www.tiktok.com/embed.js');
    loadScript('instagram-embed-script', '//www.instagram.com/embed.js');

  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [filteredContent, activeContentTab]);

  const fetchInitialData = async () => {
    try {
      const tagsResponse = await axios.get(`${API}/search/tags`);
      console.log(tagsResponse.data)
      setAllTags(tagsResponse.data.slice(0, 12));

      const contentTypes = ['video_youtube', 'file', 'instagram_reel', 'instagram_feed', 'video_tiktok'];

      const responses = await Promise.all(
        contentTypes.map(type => axios.get(`${API}/content/by-type/${type}`))
      );

      const allContent = [];
      responses.forEach(response => {
        if (response.data && Array.isArray(response.data.content)) {
          allContent.push(...response.data.content);
        }
      });

      const uniqueContent = Array.from(new Map(allContent.map(item => [item.id, item])).values());
      const shuffled = uniqueContent.sort(() => 0.5 - Math.random());
      setAllFetchedContent(shuffled);

    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  const getContentImage = (content) => {
    if (content.content_type === 'image' && content.content_data.url) {
      const separator = content.content_data.url.includes('?') ? '&' : '?';
      return `${content.content_data.url}${separator}v=${Date.now()}`;
    }
    if (content.content_type === 'video_youtube') {
      const embedUrl = content.content_data.embed_url;
      const videoId = embedUrl?.match(/embed\/([^?]*)/)?.[1];
      return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '/api/placeholder/600/300';
    }
    if (content.content_data.thumbnail_url) {
      const separator = content.content_data.thumbnail_url.includes('?') ? '&' : '?';
      return `${content.content_data.thumbnail_url}${separator}v=${Date.now()}`;
    }
    return '/api/placeholder/600/300';
  };

  const getContentLink = (content) => {
    if (content.content_type === 'video_youtube') {
      return content.content_data.embed_url?.replace('embed/', 'watch?v=');
    }
    if (content.content_type === 'video_upload' || content.content_type === 'video_tiktok') {
      return content.content_data.original_url || content.content_data.url;
    }
    if (content.content_type.includes('instagram')) {
      return content.content_data.original_url;
    }
    if (content.content_type === 'article') {
      if (content.content_data.pdf_url) {
        return content.content_data.pdf_url;
      }
      return `/article/${content.id}`;
    }
    if (content.content_type === 'file') {
      return content.content_data.url;
    }
    if (content.content_type === 'image') {
      return content.content_data.url;
    }
    return content.content_data.url || '#';
  };

  const handleSearch = async (searchQuery = query) => {
    if (!searchQuery.trim()) return;
    setLoading(true);
    setLastSearchedQuery(searchQuery); // SIMPAN QUERY DISINI UNTUK FEEDBACK WIDGET

    try {
      const localResponse = await axios.post(`${API}/search/content`, { query: searchQuery });
      const localResults = [...(localResponse.data.related_videos || []), ...(localResponse.data.related_content || [])];
      setSearchResult({
        query: searchQuery,
        local_results: localResults,
        ai_response: null,
        ai_loading: true
      });
      setAiLoading(true);
      const aiResponse = await axios.post(`${API}/search/ai`, { query: searchQuery });
      setSearchResult(prev => ({ ...prev, ai_response: aiResponse.data.ai_response, ai_loading: false }));
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      setLoading(false);
      setAiLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleTagClick = (tag) => {
    setQuery(tag);
    handleSearch(tag);
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    if (diffInHours < 1) return 'Baru saja';
    if (diffInHours < 24) return `${diffInHours} jam yang lalu`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays} hari yang lalu`;
    return date.toLocaleDateString('id-ID');
  };

  const handleDownloadPdf = async () => {
    try {
      const downloadUrl = `${API}/download-pdf?url=${encodeURIComponent(currentPdfUrl)}&filename=${encodeURIComponent(currentPdfTitle + '.pdf')}`;

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = currentPdfTitle + '.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download error:', error);
      const link = document.createElement('a');
      link.href = currentPdfUrl;
      link.download = currentPdfTitle + '.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleContentClick = (content) => {
    if (content.content_data.embed_code || content.content_data.embed_html) return;

    if (content.content_type === 'file' && content.content_data.url && content.content_data.url.toLowerCase().endsWith('.pdf')) {
      setCurrentPdfUrl(content.content_data.url);
      setCurrentPdfTitle(content.title);
      setPdfViewerOpen(true);
      return;
    }

    if (content.content_type === 'article' && content.content_data.pdf_url) {
      setCurrentPdfUrl(content.content_data.pdf_url);
      setCurrentPdfTitle(content.title);
      setPdfViewerOpen(true);
      return;
    }

    const contentLink = getContentLink(content);
    if (contentLink !== '#') {
      window.open(contentLink, '_blank');
    }
  };

  const closePdfViewer = () => {
    setPdfViewerOpen(false);
    setCurrentPdfUrl(null);
    setCurrentPdfTitle("");
  };

  const renderContent = (content) => {
    switch (content.content_type) {
      case 'video_youtube':
        return (
          <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden group">
            {content.content_data.embed_url ? (
              <iframe
                src={content.content_data.embed_url}
                title={content.title}
                className="w-full h-full rounded-lg"
                allowFullScreen
                frameBorder="0"
              />
            ) : (
              <img src={getContentImage(content)} alt={content.title} className="w-full h-full object-cover" />
            )}
            <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
              <Video className="w-3 h-3 inline mr-1" /> Video
            </div>
          </div>
        );
      case 'video_tiktok':
        return (
          <div className="flex justify-center items-center bg-transparent rounded-lg">
            {content.content_data.embed_html ? (
              <div className="w-full [&>blockquote]:m-0 [&>blockquote]:mx-auto" dangerouslySetInnerHTML={{ __html: content.content_data.embed_html }} />
            ) : (
              <a href={content.content_data.original_url} target="_blank" rel="noopener noreferrer" className="text-white bg-black rounded p-4 block">{t('view_on_tiktok')}</a>
            )}
          </div>
        );
      case 'video_upload':
        return (
          <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden group cursor-pointer" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || '16/9' }} onClick={() => handleContentClick(content)}>
            {content.content_data.url ? (
              <video controls playsInline className="w-full h-full rounded-lg object-cover"><source src={content.content_data.url} type="video/mp4" /></video>
            ) : <div className="flex items-center justify-center h-full text-gray-400"><Video className="w-8 h-8" /></div>}
            <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Video className="w-3 h-3 inline mr-1" /> Video Upload</div>
          </div>
        );
      case 'instagram_reel':
      case 'instagram_feed':
        if (content.content_data.embed_code) {
          return (
            <div className="flex justify-center w-full bg-white dark:bg-gray-900 rounded-lg overflow-hidden p-2">
              <div className="instagram-embed-wrapper w-full flex justify-center" dangerouslySetInnerHTML={{ __html: content.content_data.embed_code }} />
            </div>
          );
        }
        return (
          <div className="relative bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || (content.content_type === 'instagram_reel' ? '9/16' : '1/1'), minHeight: '300px' }} onClick={() => handleContentClick(content)}>
            {content.content_data.thumbnail_url ? <img src={content.content_data.thumbnail_url} alt={content.title} className="w-full h-full object-cover" /> : <div className="flex items-center justify-center h-full text-white"><Instagram className="w-8 h-8" /></div>}
            <div className="absolute bottom-2 left-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs px-2 py-1 rounded"><Instagram className="w-3 h-3 inline mr-1" /> {content.content_type === 'instagram_reel' ? 'Reel' : 'Post'}</div>
          </div>
        );
      case 'image':
        return (
          <div className="relative bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden cursor-pointer group" style={{ aspectRatio: content.content_data.display_options?.aspect_ratio || 'auto' }} onClick={() => handleContentClick(content)}>
            <img src={content.content_data.url} alt={content.title} className="w-full h-full object-cover" onError={(e) => { e.target.src = '/api/placeholder/600/300'; }} />
            <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded"><Image className="w-3 h-3 inline mr-1" /> Gambar</div>
          </div>
        );
      case 'article':
        if (content.content_data.pdf_url) {
          return (
            <div className="relative aspect-video bg-gradient-to-br from-red-100 to-orange-100 dark:from-red-900 dark:to-orange-900 rounded-lg overflow-hidden cursor-pointer group" onClick={() => handleContentClick(content)}>
              <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
                <FileText className="w-12 h-12 mb-3 text-red-600 dark:text-red-400" />
                <p className="text-sm font-semibold text-center mb-2 text-gray-800 dark:text-gray-200">{content.title}</p>
                <Badge className="bg-red-500 text-white">PDF Tutorial</Badge>
              </div>
              <div className="absolute inset-0 bg-red-500 opacity-0 group-hover:opacity-10 transition-opacity"></div>
            </div>
          );
        }
        return (
          <div className="aspect-video bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900 dark:to-purple-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
            <div className="text-center">
              <FileText className="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" />
              <p className="text-sm text-gray-600 dark:text-gray-300 line-clamp-3">{content.content_data.text?.substring(0, 100)}...</p>
            </div>
          </div>
        );
      case 'file':
        const isPdf = content.content_data?.url?.toLowerCase().endsWith('.pdf');
        const coverImage = content.content_data?.cover_image_url;

        // JIKA ADA COVER IMAGE
        if (coverImage) {
          return (
            <div
              className="relative aspect-video rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02] bg-cover bg-center"
              style={{ backgroundImage: `url(${coverImage})` }}
              onClick={() => handleContentClick(content)}
            >
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors"></div>

              <div className="relative z-10 flex flex-col items-center">
                <BookOpen className="w-12 h-12 mb-2 opacity-90 drop-shadow-md" />
                <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2 drop-shadow-md px-2">{content.title}</p>
                <p className="text-[9px] opacity-90 text-center mt-1 bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded-full">{t('read_click')}</p>
              </div>

              {isPdf && (
                <div className="absolute top-2 right-2 bg-red-600 shadow-md text-white text-[9px] font-bold px-1.5 py-0.5 rounded z-10">PDF</div>
              )}
            </div>
          );
        }

        // DEFAULT FALLBACK (JIKA TIDAK ADA COVER IMAGE)
        if (isPdf) {
          return (
            <div className="relative aspect-video bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg overflow-hidden group flex flex-col items-center justify-center p-4 text-white shadow-lg cursor-pointer transition-transform hover:scale-[1.02]" onClick={() => handleContentClick(content)}>
              <BookOpen className="w-12 h-12 mb-2 opacity-90" />
              <p className="text-center font-bold text-xs uppercase tracking-wider line-clamp-2">{content.title}</p>
              <p className="text-[9px] opacity-75 text-center mt-1 bg-white/20 px-2 py-0.5 rounded-full">{t('read_click')}</p>
              <div className="absolute top-2 right-2 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">PDF</div>
            </div>
          );
        }
        return (
          <div className="aspect-video bg-gradient-to-br from-green-100 to-blue-100 dark:from-green-900 dark:to-blue-900 rounded-lg flex items-center justify-center p-6 cursor-pointer group" onClick={() => handleContentClick(content)}>
            <div className="text-center">
              <FileText className="w-8 h-8 mx-auto mb-2 text-green-600 dark:text-green-400" />
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">{content.content_data.file_name || 'File'}</p>
              <Button className="bg-green-600 text-white hover:bg-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300" size="sm"><ExternalLink className="w-4 h-4 mr-2" /> {t('download')} File</Button>
            </div>
          </div>
        );
      default:
        return <div className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center"><FileText className="w-8 h-8 text-gray-400" /></div>;
    }
  };

  const particleColors = useMemo(() =>
    ['#1e1e1e', '#3b82f6', '#1d4ed8'],
    []
  );

  const navItems = [
    {
      label: "Tentang",
      bgColor: "#0D0716",
      textColor: "#fff",
      links: [
        { label: "Perusahaan", ariaLabel: "Tentang Perusahaan", href: "https://mpstore.co.id/about" },
        { label: "Karir", ariaLabel: "Karir", href: "https://mpstore.co.id/career" }
      ]
    },
    {
      label: "Layanan",
      bgColor: "#170D27",
      textColor: "#fff",
      links: [
        { label: "QRIS", ariaLabel: "QRIS", href: "https://mpstore.co.id/apps" },
        { label: "Agen Pulsa & PPOB", ariaLabel: "Agen Pulsa & PPOB", href: "#" },
        { label: "Kulakan Indomarco", ariaLabel: "Kulakan Indomarco", href: "#" },
        { label: "Logistik Kasir", ariaLabel: "Logistik Kasir", href: "#" },
        { label: "Akses Permodalan", ariaLabel: "Akses Permodalan", href: "#" },
        { label: "Miniweb", ariaLabel: "Miniweb", href: "#" }
      ]
    },
    {
      label: "Bantuan",
      bgColor: "#271E37",
      textColor: "#fff",
      links: [
        { label: "WhatsApp CS", ariaLabel: "Hubungi CS", href: "https://api.whatsapp.com/send/?phone=6285812626667" },
        { label: "Email", ariaLabel: "Email Kami", href: "mailto:support@mpstore.co.id" },
        { label: "FAQ", ariaLabel: "Tanya Jawab", href: "#" }
      ]
    }
  ];

  return (
    // CLASS 'dark' DIHAPUS DARI SINI. Hanya pakai class biasa.
    <div className="min-h-screen transition-colors duration-300 relative text-gray-900">

      <Particles
        particleColors={particleColors}
        particleCount={200}
        particleSpread={10}
        speed={0.1}
        particleBaseSize={100}
        moveParticlesOnHover={true}
        alphaParticles={false}
        disableRotation={false}
        className="fixed inset-0 w-full h-full"
      />

      {/* PDF Viewer Modal */}
      {pdfViewerOpen && (
        <Dialog open={pdfViewerOpen} onOpenChange={setPdfViewerOpen}>
          <DialogContent className="max-w-5xl w-[95vw] h-[90vh] p-0 overflow-hidden bg-zinc-900 border-zinc-800">
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between p-4 bg-zinc-900 text-white border-b border-zinc-800">
                <h3 className="font-medium truncate flex items-center gap-2">
                  <BookOpen className="w-5 h-5 text-blue-400" />
                  {currentPdfTitle || "Document Viewer"}
                </h3>
                <div className="flex items-center gap-2">
                  <button
                    onClick={handleDownloadPdf}
                    className="text-xs bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
                  >
                    <ExternalLink className="w-3 h-3 mr-1" /> {t('download')}
                  </button>
                  <a
                    href={currentPdfUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded flex items-center transition-colors"
                  >
                    <ExternalLink className="w-3 h-3 mr-1" /> {t('view_full')}
                  </a>
                  <button onClick={() => setPdfViewerOpen(false)} className="text-zinc-400 hover:text-white">
                    <X className="w-6 h-6" />
                  </button>
                </div>
              </div>
              <div className="flex-1 bg-zinc-800 relative">
                {currentPdfUrl ? (
                  <iframe
                    src={`${currentPdfUrl}#toolbar=0&view=FitH`}
                    title="PDF Viewer"
                    className="w-full h-full absolute inset-0 border-0"
                  />
                ) : (
                  <div className="flex items-center justify-center h-full text-zinc-500">
                    Memuat Dokumen...
                  </div>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}

      <div className="relative z-10 flex flex-col min-h-screen">
        <CardNav
          logo="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
          logoAlt="MPStore Logo"
          items={navItems}
          baseColor="rgba(255, 255, 255, 0.8)"
          menuColor="#000"
          buttonBgColor="#2563eb"
          buttonTextColor="#fff"
          ease="power3.out"
        />

        {/* Language Toggle - Positioning */}
        <div className="fixed top-6 right-6 z-50 flex items-center gap-2">
          <LanguageToggle />
        </div>

        <main className="container mx-auto px-4 py-8 pt-32 flex-grow">

          <div className="mb-8 w-full flex flex-col items-center text-center gap-6">
            <div className="w-full overflow-hidden mt-8">
              <SplitText
                text={t('welcome_title')}
                className="text-4xl md:text-5xl font-bold text-center text-blue-600 pb-2 drop-shadow-md"
                delay={50}
                duration={1}
                ease="back.out(1.7)"
                threshold={0.1}
                rootMargin="-50px"
                onLetterAnimationComplete={handleAnimationComplete}
              />
            </div>

            <div className="min-h-[40px]">
              <TextType
                text={[
                  t('typing_1'),
                  t('typing_2'),
                  t('typing_3')
                ]}
                className="text-lg md:text-xl text-gray-600 font-medium"
                typingSpeed={50}
                pauseDuration={2000}
                deletingSpeed={30}
                cursorCharacter="|"
                cursorClassName="text-blue-500 font-bold"
              />
            </div>

            <div className="w-full max-w-2xl mx-auto mt-4">
              <div className="relative group">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 blur"></div>
                <div className="relative flex bg-white rounded-full p-1">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <Input
                    type="text"
                    placeholder={t('search_placeholder')}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyPress={handleKeyPress}
                    className="pl-12 pr-4 py-6 w-full bg-transparent border-0 focus:ring-0 focus-visible:ring-0 rounded-full text-lg"
                  />
                  {query && (
                    <Button
                      onClick={() => handleSearch()}
                      disabled={loading}
                      className="rounded-full px-8 bg-blue-600 hover:bg-blue-700 text-white"
                    >
                      {loading ? t('searching') : t('search_button')}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {searchResult && (
            <section className="mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="max-w-4xl mx-auto space-y-8">
                <div className="text-center">
                  <h2 className="text-3xl font-bold mb-4">
                    {t('search_result')}: "{searchResult.query}"
                  </h2>
                  <Button variant="outline" onClick={() => setSearchResult(null)} className="rounded-full">
                    ← {t('back_home')}
                  </Button>
                </div>

                {/* --- FEEDBACK WIDGET YANG DITAMBAHKAN --- */}
                <FeedbackWidget query={lastSearchedQuery} />
                {/* -------------------------------------- */}

                <Card className="bg-white/90 backdrop-blur-sm border-l-4 border-blue-500 shadow-lg">
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                        <span className="text-white text-sm font-bold">AI</span>
                      </div>
                      {t('ai_answer')}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    {searchResult.ai_loading ? (
                      <div className="flex items-center gap-2">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                        <span className="text-gray-600">{t('analyzing')}</span>
                      </div>
                    ) : searchResult.ai_response ? (
                      <div className="prose prose-sm max-w-none">
                        <p className="whitespace-pre-wrap">{searchResult.ai_response}</p>
                      </div>
                    ) : (
                      <p className="text-gray-500">{t('no_ai_response')}</p>
                    )}
                  </CardContent>
                </Card>

                {searchResult.local_results && searchResult.local_results.length > 0 && (
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {searchResult.local_results.map((content) => (
                      <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/80 backdrop-blur-sm overflow-hidden cursor-pointer" onClick={() => handleContentClick(content)}>
                        <div className="relative">{renderContent(content)}</div>
                        <CardContent className="p-4">
                          <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
                            <span>{formatTimeAgo(content.created_at)}</span>
                          </div>
                          <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
                            {content.title}
                          </h4>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                )}
              </div>
            </section>
          )}

          {!searchResult && (
            <>
              <section className="mb-8 mt-12">
                <h3 className="text-2xl font-bold mb-6 text-center">{t('popular_categories')}</h3>
                <div className="flex flex-wrap justify-center gap-3">
                  {allTags.map((tag) => (
                    <Button key={tag} variant="outline" onClick={() => handleTagClick(tag)} className="rounded-full bg-white/50 hover:bg-blue-50 border-gray-300 backdrop-blur-sm">
                      {tag}
                    </Button>
                  ))}
                </div>
              </section>

              <div className="mb-1">
                <CurvedLoop
                  marqueeText="Kasir | Qris | Akses Permodalan | Mini Website | Agen Pulsa & PPOB | Kulakan Indomarco | Logistik"
                  speed={2}
                  curveAmount={0}
                  className="text-grey-600"
                />
              </div>

              <section className="mb-8">
                <div className="flex space-x-1 mb-6 bg-gray-100/80 p-1 rounded-full max-w-md backdrop-blur-sm mx-auto">
                  {[
                    { id: 'video', label: t('tab_video') },
                    { id: 'buku tutorial', label: t('tab_book') },
                    { id: 'konten', label: t('tab_content') }
                  ].map((tab) => (
                    <Button
                      key={tab.id}
                      variant={activeContentTab === tab.id ? "default" : "ghost"}
                      size="sm"
                      onClick={() => setActiveContentTab(tab.id)}
                      className={`flex-1 rounded-full transition-all ${activeContentTab === tab.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-200'}`}
                    >
                      {tab.label}
                    </Button>
                  ))}
                </div>
              </section>

              <div className="grid lg:grid-cols-4 gap-8">
                <div className="lg:col-span-3">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-y-auto max-h-[calc(100vh-50px)] pr-4 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200">
                    {filteredContent.length === 0 ? (
                      <div className="col-span-full text-center py-12 text-gray-500">
                        <p>{t('no_content')}</p>
                      </div>
                    ) : (
                      filteredContent.map((content) => (
                        <Card key={content.id} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-sm bg-white/90 backdrop-blur-sm cursor-pointer" onClick={() => handleContentClick(content)}>
                          <div className="relative overflow-hidden">{renderContent(content)}</div>
                          <CardContent className="p-4">
                            <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
                              <span>{formatTimeAgo(content.created_at)}</span>
                              <div className="flex items-center space-x-3"><span className="flex items-center"><Eye className="w-3 h-3 mr-1" />{Math.floor(Math.random() * 1000)}</span></div>
                            </div>
                            <h4 className="font-semibold text-sm mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</h4>
                            <div className="flex flex-wrap gap-1">{content.tags.slice(0, 2).map((tag) => (<Badge key={tag} variant="secondary" className="text-xs bg-gray-100/80">{tag}</Badge>))}</div>
                          </CardContent>
                        </Card>
                      ))
                    )}
                  </div>
                </div>

                <div className="lg:col-span-1">
                  <div className="sticky top-24 space-y-6">
                    <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
                      <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><TrendingUp className="w-5 h-5 mr-2 text-orange-500" /> {t('trending')}</CardTitle></CardHeader>
                      <CardContent className="space-y-4">
                        {trendingContent.map((content, index) => (
                          <div key={content.id} className="flex items-start space-x-3 group cursor-pointer" onClick={() => handleContentClick(content)}>
                            <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${index === 0 ? 'bg-yellow-500 text-white' : index === 1 ? 'bg-gray-400 text-white' : index === 2 ? 'bg-yellow-600 text-white' : 'bg-gray-200 text-gray-600'}`}>{index + 1}</div>
                            <div className="flex-1 min-w-0"><p className="text-sm font-medium line-clamp-2 group-hover:text-blue-600 transition-colors">{content.title}</p><p className="text-xs text-gray-500 mt-1">{Math.floor(Math.random() * 500) + 100} views</p></div>
                          </div>
                        ))}
                      </CardContent>
                    </Card>
                    <Card className="border-0 shadow-sm bg-white/80 backdrop-blur-sm">
                      <CardHeader className="pb-4"><CardTitle className="flex items-center text-lg"><Star className="w-5 h-5 mr-2 text-blue-500" /> {t('resources')}</CardTitle></CardHeader>
                      <CardContent className="space-y-3">
                        <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://apps.apple.com/id/app/mpstore-superapp-umkm/id1514516462?mt=8', '_blank')}><Smartphone className="w-4 h-4 mr-2" /> {t('download_app')}</Button>
                        <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.instagram.com/mpstore_superappumkm/', '_blank')}><Instagram className="w-4 h-4 mr-2" /> Instagram</Button>
                        <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://www.facebook.com/people/MPStore/100087175355298/', '_blank')}><Facebook className="w-4 h-4 mr-2" /> Facebook</Button>
                        <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285812626667&text&type=phone_number&app_absent=0', '_blank')}><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp CS</Button>
                        <Button variant="outline" className="w-full justify-start bg-transparent hover:bg-gray-100" onClick={() => window.open('https://mpstore.co.id/news/', '_blank')}><Newspaper className="w-4 h-4 mr-2" /> {t('news_updates')}</Button>
                      </CardContent>
                    </Card>
                  </div>
                </div>
              </div>
            </>
          )}
        </main>

        <Footer />

        <div className="fixed bottom-6 right-6 z-50">
          <Button
            onClick={() => window.location.href = '/admin'}
            variant="outline"
            className="shadow-lg rounded-full h-12 w-12 p-0 bg-white"
          >
            <Settings className="w-6 h-6" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModernHomepage;